
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fPkg5", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $gZFfs = parcelRequire("gZFfs");

var $4XQZr = parcelRequire("4XQZr");


var $kbCR7 = parcelRequire("kbCR7");


var $8gekW = parcelRequire("8gekW");


var $gMVCA = parcelRequire("gMVCA");

// temp solution until a proper versioning
const $4ebb8e873c8c2779$export$93809551debf385f = '0.1.7';



var $aHYhi = parcelRequire("aHYhi");







class $0c39cd03fba959c1$export$faf4c91b80fc830e {
    push(event) {
        (0, $8gekW.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $gMVCA.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $gMVCA.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $gMVCA.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $gMVCA.SUBSCRIBE_ALL]) this.subscribers[0, $gMVCA.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $8gekW.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}











const $e5c76aaa8ff0485e$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $gZFfs.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};


const $9e4cd00245556668$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};






const $4856799396fa2f0f$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $4856799396fa2f0f$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $4856799396fa2f0f$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};


const $b4441236af263a9f$export$b98e411ae80c806f = '/';


const $b449a4236bc6c1d0$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $b449a4236bc6c1d0$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $b449a4236bc6c1d0$var$SSR_PREFIX = 'ssr';
const $b449a4236bc6c1d0$var$mapKey = (key)=>{
    if (key === 'total') return $b449a4236bc6c1d0$var$SSR_PREFIX;
    return `${$b449a4236bc6c1d0$var$SSR_PREFIX}${0, $b4441236af263a9f$export$b98e411ae80c806f}${key}`;
};
const $b449a4236bc6c1d0$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($b449a4236bc6c1d0$var$filterEntry(entry[1])) acc[$b449a4236bc6c1d0$var$mapKey(entry[0])] = $b449a4236bc6c1d0$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};


const $45f5349ee3a2563c$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $gZFfs.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $4856799396fa2f0f$export$6126f85083a72c6e)(data);
    const ssr = (0, $e5c76aaa8ff0485e$export$7167d96e9881d500)(data) ? (0, $b449a4236bc6c1d0$export$130f411261a599c5)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};


const $93b583dcf4df750b$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $93b583dcf4df750b$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $93b583dcf4df750b$export$9aa44f85591248d9() || {};
    return performance;
};
const $93b583dcf4df750b$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $93b583dcf4df750b$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};


const $304a72d014eeaaed$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $93b583dcf4df750b$export$8cd0c777b0eb66a0)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};



// @flow strict-local




const $531c661b0eb6bfb5$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $93b583dcf4df750b$export$8cd0c777b0eb66a0)(), PerformanceObserver1 = (0, $93b583dcf4df750b$export$74560fd4e61fd440)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($531c661b0eb6bfb5$export$bea963256235a63e.observer) {
            (0, $8gekW.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $531c661b0eb6bfb5$export$bea963256235a63e.timings = resources.map((resource)=>$531c661b0eb6bfb5$export$bea963256235a63e.transformResource(resource));
        $531c661b0eb6bfb5$export$bea963256235a63e.observer = new PerformanceObserver1($531c661b0eb6bfb5$export$bea963256235a63e.addTimings);
        $531c661b0eb6bfb5$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($531c661b0eb6bfb5$export$bea963256235a63e.observer) {
            $531c661b0eb6bfb5$export$bea963256235a63e.observer.disconnect();
            $531c661b0eb6bfb5$export$bea963256235a63e.observer = null;
        }
        $531c661b0eb6bfb5$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$531c661b0eb6bfb5$export$bea963256235a63e.transformResource(entry));
        const overflow = $531c661b0eb6bfb5$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $531c661b0eb6bfb5$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $531c661b0eb6bfb5$export$bea963256235a63e.maxSize;
            $531c661b0eb6bfb5$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $531c661b0eb6bfb5$export$bea963256235a63e.timings.push(...entries);
    }
};
const $531c661b0eb6bfb5$export$9eebb59359c2e9e5 = (startTime, performance = (0, $93b583dcf4df750b$export$8cd0c777b0eb66a0)())=>{
    if (!PerformanceObserver || !$531c661b0eb6bfb5$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $531c661b0eb6bfb5$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};


const $a7f551e141177dcc$var$cacheableTypes = [
    'script',
    'link'
];
const $a7f551e141177dcc$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $a7f551e141177dcc$var$CACHE_NETWORK = 'network';
const $a7f551e141177dcc$var$CACHE_MEMORY = 'memory';
const $a7f551e141177dcc$var$CACHE_DISK = 'disk';
const $a7f551e141177dcc$var$calculateTransferType = (type, duration, size)=>{
    if (!$a7f551e141177dcc$var$cacheableTypes.includes(type)) return $a7f551e141177dcc$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $a7f551e141177dcc$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $a7f551e141177dcc$var$CACHE_DISK;
    if (size === undefined) return null;
    return $a7f551e141177dcc$var$CACHE_NETWORK;
};
const $a7f551e141177dcc$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$a7f551e141177dcc$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $93b583dcf4df750b$export$9aa44f85591248d9)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $a7f551e141177dcc$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $a7f551e141177dcc$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $a7f551e141177dcc$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $a7f551e141177dcc$var$getNetworkData = (item, eventStart, hasTimingHeaders = $a7f551e141177dcc$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$a7f551e141177dcc$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($a7f551e141177dcc$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $a7f551e141177dcc$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$a7f551e141177dcc$var$getSizeObject(transferSize)
        };
        if (transferType !== $a7f551e141177dcc$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$a7f551e141177dcc$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$a7f551e141177dcc$var$getSizeObject(transferSize)
    };
};
const $a7f551e141177dcc$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $93b583dcf4df750b$export$8cd0c777b0eb66a0)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $531c661b0eb6bfb5$export$9eebb59359c2e9e5)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $a7f551e141177dcc$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $a7f551e141177dcc$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$a7f551e141177dcc$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};


const $4e8f7782393ca0c8$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $4e8f7782393ca0c8$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $4e8f7782393ca0c8$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $4e8f7782393ca0c8$var$getHistogram = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $gZFfs.ExperiencePerformanceTypes).PageLoad:
            case (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$4e8f7782393ca0c8$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$4e8f7782393ca0c8$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $gZFfs.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$4e8f7782393ca0c8$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$4e8f7782393ca0c8$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $gZFfs.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$4e8f7782393ca0c8$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};
const $4e8f7782393ca0c8$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $gMVCA.FMP_MARK))?.time || (0, $e5c76aaa8ff0485e$export$7167d96e9881d500)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$4e8f7782393ca0c8$var$LoadMetricKeys.tti]: Math.round(tti),
        [$4e8f7782393ca0c8$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$4e8f7782393ca0c8$var$getHistogram(data, performanceConfig)
    };
};
const $4e8f7782393ca0c8$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $gMVCA.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$4e8f7782393ca0c8$var$InlineResultMetricKeys.result]: Math.round(result),
        [$4e8f7782393ca0c8$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$4e8f7782393ca0c8$var$getHistogram(data, performanceConfig)
    };
};
const $4e8f7782393ca0c8$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$4e8f7782393ca0c8$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$4e8f7782393ca0c8$var$getHistogram(data, performanceConfig)
    };
};
const $4e8f7782393ca0c8$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $gZFfs.ExperiencePerformanceTypes).PageLoad:
        case (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad:
            return $4e8f7782393ca0c8$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $gZFfs.ExperiencePerformanceTypes).InlineResult:
            return $4e8f7782393ca0c8$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $gZFfs.ExperiencePerformanceTypes).Custom:
            return $4e8f7782393ca0c8$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $4e8f7782393ca0c8$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$4e8f7782393ca0c8$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $a7f551e141177dcc$export$81a7d52441a06b50)(data, resourceConfig),
        ...(0, $304a72d014eeaaed$export$1a2bb347935fc536)(data, bundleEvalConfig),
        ...(0, $45f5349ee3a2563c$export$e952f50a4f2d02da)(data, ssr),
        ...(0, $e5c76aaa8ff0485e$export$7167d96e9881d500)(data) ? (0, $9e4cd00245556668$export$b88d990436be0f8a)() : null
    };
};





const $d5a9eb450677708e$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $gMVCA.PageVisibleState).HIDDEN : (0, $gMVCA.PageVisibleState).VISIBLE)
    };
};



const $628d46c8c56c9dd3$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};


const $4fdaab2e79f2d151$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};



var $9hBK5 = parcelRequire("9hBK5");


var $dOBRD = parcelRequire("dOBRD");


const $a4e6331af2ab6ae7$export$f435c2789ca334a7 = (0, $dOBRD.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9hBK5))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($9hBK5))).getParser((0, $93b583dcf4df750b$export$9aa44f85591248d9)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});





const $c6ecf5bd35df4d5b$export$db7649b8854107ad = (0, $dOBRD.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});


const $511861ce72d01293$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};





const $04927df0b9b3e793$export$81efaf8414879a1a = (0, $dOBRD.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});


const $106483fffec146ef$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};


const $61f40c3e2a1e7055$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};


const $e1797b93c3881ed3$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};


const $99de85caa273c5dd$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};




const $943a72b2f3162eda$var$UNKNOWN_VALUE = 'unknown';
const $943a72b2f3162eda$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $943a72b2f3162eda$var$UNKNOWN_VALUE,
    id: $943a72b2f3162eda$var$UNKNOWN_VALUE,
    uuid: $943a72b2f3162eda$var$UNKNOWN_VALUE,
    state: {
        id: $943a72b2f3162eda$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $gZFfs.ExperienceTypes).Experience,
    category: $943a72b2f3162eda$var$UNKNOWN_VALUE,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $gMVCA.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $943a72b2f3162eda$var$Publisher {
    publish(data) {
        const payloadStart = (0, $93b583dcf4df750b$export$8cd0c777b0eb66a0)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $8gekW.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$943a72b2f3162eda$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $4ebb8e873c8c2779$export$93809551debf385f) || $943a72b2f3162eda$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $a4e6331af2ab6ae7$export$f435c2789ca334a7)(),
                    ...(0, $c6ecf5bd35df4d5b$export$db7649b8854107ad)(),
                    ...(0, $04927df0b9b3e793$export$81efaf8414879a1a)(),
                    ...(0, $106483fffec146ef$export$ce1cf816dce1da56)(),
                    ...(0, $628d46c8c56c9dd3$export$e34e4529b979f74c)(this.app),
                    ...(0, $4fdaab2e79f2d151$export$82ae485178b37419)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $aHYhi.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $d5a9eb450677708e$export$723b4c298aca63af)(supportedData),
                    ...(0, $e5c76aaa8ff0485e$export$7167d96e9881d500)(supportedData) && (0, $e1797b93c3881ed3$export$a3dc8251cf55b2e0)(this.ssr),
                    ...(0, $e5c76aaa8ff0485e$export$7167d96e9881d500)(supportedData) && (0, $61f40c3e2a1e7055$export$fdbea518c19dfa8)(this.ssr),
                    ...this.featureFlagClient && (0, $511861ce72d01293$export$e62953d023125748)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: {
                    ...this.getPerformanceMetrics(supportedData),
                    ...supportedData.traceContext && (0, $iDrrr.fg)('ufo_v1_tracing_2') ? {
                        'ufo:tracingContext': {
                            'X-B3-TraceId': supportedData.traceContext.traceId,
                            'X-B3-SpanId': supportedData.traceContext.spanId,
                            browserTimeOrigin: (0, $93b583dcf4df750b$export$8cd0c777b0eb66a0)()?.timeOrigin ?? 0
                        }
                    } : null
                },
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $93b583dcf4df750b$export$8cd0c777b0eb66a0)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $8gekW.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $kbCR7.getGlobalEventStream)() instanceof (0, $0c39cd03fba959c1$export$faf4c91b80fc830e))) {
            const eventStream = new (0, $0c39cd03fba959c1$export$faf4c91b80fc830e)();
            eventStream.push({
                type: (0, $gMVCA.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $kbCR7.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $4XQZr.visibilityChangeObserver).start();
        (0, $531c661b0eb6bfb5$export$bea963256235a63e).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $4e8f7782393ca0c8$export$738d24377baf6a5e)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $943a72b2f3162eda$var$UNKNOWN_VALUE;
        this.hostname = (0, $93b583dcf4df750b$export$9aa44f85591248d9)()?.location?.hostname || '';
        this.tenantType = (0, $aHYhi.TenantType).RealUser;
        this.app = {
            version: {
                web: $943a72b2f3162eda$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $99de85caa273c5dd$export$e7b0ac011bb776c6);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $943a72b2f3162eda$export$edb879ae55bb9be3 = new $943a72b2f3162eda$var$Publisher();
module.exports["payloadPublisher"] = $943a72b2f3162eda$export$edb879ae55bb9be3;

});

parcelRegister("aHYhi", function(module, exports) {

var $b1170c3ad1e6a74d$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});
module.exports["TenantType"] = $b1170c3ad1e6a74d$export$92a757ac1398962f;

});

parcelRegister("hnAeG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");





var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");

const $4fb85e2831c07c18$var$flagIconByType = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-information, #357DE8)"
    })
};
const $4fb85e2831c07c18$var$DefaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
    spacing: "spacious",
    label: "",
    color: "var(--ds-icon-success, #6A9A23)"
});
const $4fb85e2831c07c18$export$672f92b0d52b7cfe = (type = 'normal')=>$4fb85e2831c07c18$var$flagIconByType[type] || $4fb85e2831c07c18$var$DefaultIcon;



var $blOKM = parcelRequire("blOKM");


var $24Rm0 = parcelRequire("24Rm0");

const $14a66f5ffe82eada$var$error = new Error('AppConfig is not setup in RSS');
const $14a66f5ffe82eada$var$defaultValue = {
    push: ()=>{
        throw $14a66f5ffe82eada$var$error;
    },
    replace: ()=>{
        throw $14a66f5ffe82eada$var$error;
    },
    addFlag: ()=>{
        throw $14a66f5ffe82eada$var$error;
    },
    removeFlag: ()=>{}
};
const $14a66f5ffe82eada$var$AppConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($14a66f5ffe82eada$var$defaultValue);
const $14a66f5ffe82eada$export$42f491f31057ae78 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AppConfigProvider(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { children: children, push: pushProp, replace: replaceProp, addFlag: addFlagProp, removeFlag: removeFlag } = t0;
    const { contextEntryPoint: contextEntryPoint } = (0, $24Rm0.useNavigationState)();
    let t1;
    if ($[0] !== addFlagProp) {
        t1 = (props)=>{
            const { type: type, ...rest } = props;
            addFlagProp({
                ...rest,
                id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
                type: type,
                appearance: "normal",
                icon: (0, $4fb85e2831c07c18$export$672f92b0d52b7cfe)(type)
            });
        };
        $[0] = addFlagProp;
        $[1] = t1;
    } else t1 = $[1];
    const addFlag = t1;
    let t2;
    if ($[2] !== contextEntryPoint || $[3] !== pushProp) {
        t2 = (path)=>{
            const finalPath = (0, $blOKM.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return pushProp(finalPath);
        };
        $[2] = contextEntryPoint;
        $[3] = pushProp;
        $[4] = t2;
    } else t2 = $[4];
    const push = t2;
    let t3;
    if ($[5] !== contextEntryPoint || $[6] !== replaceProp) {
        t3 = (path_0)=>{
            const finalPath_0 = (0, $blOKM.prefixWithContextEntryPoint)(path_0, contextEntryPoint);
            return replaceProp(finalPath_0);
        };
        $[5] = contextEntryPoint;
        $[6] = replaceProp;
        $[7] = t3;
    } else t3 = $[7];
    const replace = t3;
    const t4 = removeFlag || $14a66f5ffe82eada$var$_temp;
    let t5;
    if ($[8] !== addFlag || $[9] !== push || $[10] !== replace || $[11] !== t4) {
        t5 = {
            addFlag: addFlag,
            removeFlag: t4,
            push: push,
            replace: replace
        };
        $[8] = addFlag;
        $[9] = push;
        $[10] = replace;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    const configValue = t5;
    let t6;
    if ($[13] !== children || $[14] !== configValue) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($14a66f5ffe82eada$var$AppConfigContext.Provider, {
            value: configValue
        }, children);
        $[13] = children;
        $[14] = configValue;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function AppConfigProvider({ children: children, push: pushProp, replace: replaceProp, addFlag: addFlagProp, removeFlag: removeFlag }) {
    const { contextEntryPoint: contextEntryPoint } = (0, $24Rm0.useNavigationState)();
    const addFlag = (0, $cozmU.useCallback)((props)=>{
        const { type: type, ...rest } = props;
        addFlagProp({
            ...rest,
            id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
            type: type,
            appearance: 'normal',
            icon: (0, $4fb85e2831c07c18$export$672f92b0d52b7cfe)(type)
        });
    }, [
        addFlagProp
    ]);
    const push = (0, $cozmU.useCallback)((path)=>{
        const finalPath = (0, $blOKM.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return pushProp(finalPath);
    }, [
        pushProp,
        contextEntryPoint
    ]);
    const replace = (0, $cozmU.useCallback)((path_0)=>{
        const finalPath_0 = (0, $blOKM.prefixWithContextEntryPoint)(path_0, contextEntryPoint);
        return replaceProp(finalPath_0);
    }, [
        contextEntryPoint,
        replaceProp
    ]);
    const configValue = (0, $cozmU.useMemo)(()=>({
            addFlag: addFlag,
            removeFlag: removeFlag || (()=>{}),
            push: push,
            replace: replace
        }), [
        addFlag,
        removeFlag,
        push,
        replace
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($14a66f5ffe82eada$var$AppConfigContext.Provider, {
        value: configValue
    }, children);
};
function $14a66f5ffe82eada$var$_temp() {}
const $14a66f5ffe82eada$var$useAppConfigProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($14a66f5ffe82eada$var$AppConfigContext);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($14a66f5ffe82eada$var$AppConfigContext);
const $14a66f5ffe82eada$export$d52b0df9de5d0e40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { push: push, replace: replace } = $14a66f5ffe82eada$var$useAppConfigProvider();
    let t0;
    if ($[0] !== push || $[1] !== replace) {
        t0 = {
            push: push,
            replace: replace
        };
        $[0] = push;
        $[1] = replace;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const { push: push, replace: replace } = $14a66f5ffe82eada$var$useAppConfigProvider();
    return {
        push: push,
        replace: replace
    };
};
const $14a66f5ffe82eada$export$6d75236f0e3dc17e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { addFlag: addFlag } = $14a66f5ffe82eada$var$useAppConfigProvider();
    return addFlag;
} : ()=>{
    const { addFlag: addFlag } = $14a66f5ffe82eada$var$useAppConfigProvider();
    return addFlag;
};
const $14a66f5ffe82eada$export$42e65147194910be = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { removeFlag: removeFlag } = $14a66f5ffe82eada$var$useAppConfigProvider();
    return removeFlag;
} : ()=>{
    const { removeFlag: removeFlag } = $14a66f5ffe82eada$var$useAppConfigProvider();
    return removeFlag;
};
module.exports["AppConfigProvider"] = $14a66f5ffe82eada$export$42f491f31057ae78;
module.exports["useNavigationActions"] = $14a66f5ffe82eada$export$d52b0df9de5d0e40;
module.exports["useAddFlag"] = $14a66f5ffe82eada$export$6d75236f0e3dc17e;
module.exports["useRemoveFlag"] = $14a66f5ffe82eada$export$42e65147194910be;

});

parcelRegister("blOKM", function(module, exports) {

var $c9hBE = parcelRequire("c9hBE");


var $kz7tR = parcelRequire("kz7tR");

const $0f7a234b4d754282$export$895d6838d29edd02 = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $0f7a234b4d754282$export$715c8f9057ac0c01 = (path, contextEntryPoint = null)=>{
    if ($0f7a234b4d754282$export$895d6838d29edd02(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $0f7a234b4d754282$export$d614758658023fd = (url)=>{
    if (!$0f7a234b4d754282$export$895d6838d29edd02(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $kz7tR.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $0f7a234b4d754282$export$4cf71c31cd7fa836 = {
    WHAT_IS_A_TEAM: `${(0, $c9hBE.getAtlassianContextUrl)('support')}/platform-experiences/docs/start-an-atlassian-team/`,
    TEAM_INVITE_LEARN_MORE: `${(0, $c9hBE.getAtlassianContextUrl)('support')}/atlassian-account/docs/start-an-atlassian-team/#Add-or-remove-members-of-a-team`
};
module.exports["isAbsoluteLink"] = $0f7a234b4d754282$export$895d6838d29edd02;
module.exports["prefixWithContextEntryPoint"] = $0f7a234b4d754282$export$715c8f9057ac0c01;
module.exports["getRelativeUrl"] = $0f7a234b4d754282$export$d614758658023fd;
module.exports["EXTERNAL_LINKS"] = $0f7a234b4d754282$export$4cf71c31cd7fa836;

});

parcelRegister("kz7tR", function(module, exports) {

var $aEO8E = parcelRequire("aEO8E");

const $e0da7ad9916d0a36$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $e0da7ad9916d0a36$export$f86b2a1a2ce291b3 = (0, $aEO8E.logExceptionWithPackageContext)($e0da7ad9916d0a36$var$packageContext);
const $e0da7ad9916d0a36$export$ece28f5cfa04608 = (0, $aEO8E.logErrorMessageWithPackageContext)($e0da7ad9916d0a36$var$packageContext);
const $e0da7ad9916d0a36$export$386587bcf05ee8ea = (0, $aEO8E.logInfoMessageWithPackageContext)($e0da7ad9916d0a36$var$packageContext);
const $e0da7ad9916d0a36$export$9edc7d6f1c33ddc = (0, $aEO8E.createErrorHandlerWithPackageContext)($e0da7ad9916d0a36$var$packageContext);
module.exports["logException"] = $e0da7ad9916d0a36$export$f86b2a1a2ce291b3;
module.exports["logErrorMessage"] = $e0da7ad9916d0a36$export$ece28f5cfa04608;
module.exports["logInfoMessage"] = $e0da7ad9916d0a36$export$386587bcf05ee8ea;

});

parcelRegister("ibRl2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7MeEG = parcelRequire("7MeEG");

class $fb646fb94f5f9993$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7MeEG.AnalyticsContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            analytics: this.props.analytics
        };
    }
}
module.exports["default"] = $fb646fb94f5f9993$export$2e2bcd8739ae039;

});

parcelRegister("9e1Ur", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");











var $aRGok = parcelRequire("aRGok");


var $g1Weo = parcelRequire("g1Weo");

/**
 * DialogRenderer is used to render actual Dialog inside AK ModalTransition.
 */ const $24e66c959ea63cc9$var$DialogRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DialogRenderer(props) {
    const $ = (0, $bDgLe.c)(11);
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose, dialogProps: dialogProps } = props;
    const { closeDialog: closeDialog } = (0, $cozmU.useContext)((0, $g1Weo.DialogsContext));
    if (!DialogComponent) return null;
    let t0;
    if ($[0] !== closeDialog || $[1] !== dialogProps || $[2] !== onClose) {
        t0 = ()=>{
            closeDialog();
            if (onClose) onClose();
            if (dialogProps?.onClose) dialogProps.onClose();
        };
        $[0] = closeDialog;
        $[1] = dialogProps;
        $[2] = onClose;
        $[3] = t0;
    } else t0 = $[3];
    const handleCloseDialog = t0;
    let t1;
    if ($[4] !== DialogComponent || $[5] !== dialogProps || $[6] !== handleCloseDialog || $[7] !== isOpen) {
        t1 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DialogComponent, {
            ...dialogProps,
            onClose: handleCloseDialog
        });
        $[4] = DialogComponent;
        $[5] = dialogProps;
        $[6] = handleCloseDialog;
        $[7] = isOpen;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[9] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t1);
        $[9] = t1;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : function DialogRenderer(props) {
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose, dialogProps: dialogProps } = props;
    const { closeDialog: closeDialog } = (0, $cozmU.useContext)((0, $g1Weo.DialogsContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
        if (dialogProps?.onClose) dialogProps.onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DialogComponent, {
        ...dialogProps,
        onClose: handleCloseDialog
    }));
};
var $24e66c959ea63cc9$export$2e2bcd8739ae039 = $24e66c959ea63cc9$var$DialogRenderer;





const $1c5cd23aaedd8161$var$initialStates = {
    DialogComponent: null,
    dialogProps: null,
    isOpen: false
};
function $1c5cd23aaedd8161$var$dialogReducer(state, action) {
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                dialogProps: action.payload?.dialogProps || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error();
    }
}
const $1c5cd23aaedd8161$var$DialogsProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DialogsProvider(props) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = props;
    const [stateDialogProvider, dispatch] = (0, $cozmU.useReducer)($1c5cd23aaedd8161$var$dialogReducer, $1c5cd23aaedd8161$var$initialStates);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            openDialog: (DialogComponent, t1)=>{
                const dialogProps = t1 === undefined ? null : t1;
                return dispatch({
                    type: "open",
                    payload: {
                        DialogComponent: DialogComponent,
                        dialogProps: dialogProps
                    }
                });
            },
            closeDialog: ()=>dispatch({
                    type: "close"
                })
        };
        $[0] = t0;
    } else t0 = $[0];
    const valueProvider = t0;
    let t1;
    if ($[1] !== stateDialogProvider) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24e66c959ea63cc9$export$2e2bcd8739ae039), stateDialogProvider);
        $[1] = stateDialogProvider;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== children || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g1Weo.DialogsContext).Provider, {
            value: valueProvider
        }, children, t1);
        $[3] = children;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function DialogsProvider(props) {
    const { children: children } = props;
    const [stateDialogProvider, dispatch] = (0, $cozmU.useReducer)($1c5cd23aaedd8161$var$dialogReducer, $1c5cd23aaedd8161$var$initialStates);
    const valueProvider = (0, $cozmU.useMemo)(()=>({
            openDialog: (DialogComponent, dialogProps = null)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent,
                        dialogProps: dialogProps
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g1Weo.DialogsContext).Provider, {
        value: valueProvider
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24e66c959ea63cc9$export$2e2bcd8739ae039), stateDialogProvider)));
};
var $1c5cd23aaedd8161$export$2e2bcd8739ae039 = $1c5cd23aaedd8161$var$DialogsProvider;
module.exports["default"] = $1c5cd23aaedd8161$export$2e2bcd8739ae039;

});

parcelRegister("g1Weo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $876cace5e8a574b9$var$dialogsContextState = {
    openDialog: ()=>null,
    closeDialog: ()=>null
};
const $876cace5e8a574b9$export$412f7f691e39b0da = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($876cace5e8a574b9$var$dialogsContextState);
module.exports["DialogsContext"] = $876cace5e8a574b9$export$412f7f691e39b0da;

});

parcelRegister("1M2bR", function(module, exports) {
var $796348eef2f412f7$export$b89d4f1cb2ee533c = /*#__PURE__*/ function(TeamProfileErrorType) {
    TeamProfileErrorType["TEAM_MISSING"] = "teamMissing";
    TeamProfileErrorType["NO_PERMISSION"] = "noPermission";
    TeamProfileErrorType["TEAM_DELETED"] = "deleted";
    TeamProfileErrorType["UNKNOWN"] = "unknown";
    TeamProfileErrorType["NO_ACCESS_TO_TEAMS"] = "noAccessToTeams";
    return TeamProfileErrorType;
}({});
module.exports["TeamProfileErrorType"] = $796348eef2f412f7$export$b89d4f1cb2ee533c;

});

parcelRegister("2a7Yo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $NF6kd = parcelRequire("NF6kd");

var $l7jo6 = parcelRequire("l7jo6");


var $dtuCc = parcelRequire("dtuCc");

var $dea2s = parcelRequire("dea2s");

var $96X1W = parcelRequire("96X1W");


var $fPkg5 = parcelRequire("fPkg5");


var $56jml = parcelRequire("56jml");


var $gLv2X = parcelRequire("gLv2X");


var $akp1l = parcelRequire("akp1l");

function $0e260035dadfd7bc$var$getServerName() {
    return window.location.hostname;
}
const { LOCAL: $0e260035dadfd7bc$var$LOCAL, DEV: $0e260035dadfd7bc$var$DEV, STAGING: $0e260035dadfd7bc$var$STAGING, PROD: $0e260035dadfd7bc$var$PROD } = (0, $l7jo6.envType);
// disabled because of linting error that upon fixing, breaks the typing
// @ts-ignore
const $0e260035dadfd7bc$var$ENV_MAP = {
    local: $0e260035dadfd7bc$var$LOCAL,
    test: $0e260035dadfd7bc$var$LOCAL,
    adev: $0e260035dadfd7bc$var$DEV,
    'stg-east': $0e260035dadfd7bc$var$STAGING,
    stg: $0e260035dadfd7bc$var$STAGING
};
// disabled because of linting error that upon fixing, breaks the typing
// @ts-ignore
const $0e260035dadfd7bc$var$getEnvType = (env)=>{
    return $0e260035dadfd7bc$var$ENV_MAP[env] || $0e260035dadfd7bc$var$PROD;
};
const $0e260035dadfd7bc$var$analyticsConfig = (0, $dea2s.getConfig)().analytics;
const $0e260035dadfd7bc$var$SUB_PRODUCT_DEFAULT = 'siteDirectory';
const $0e260035dadfd7bc$var$PRODUCT_DEFAULT = 'people';
class $0e260035dadfd7bc$var$AnalyticsClient {
    setTeamId(teamId) {
        this.teamId = teamId;
    }
    setConsumer(consumer) {
        this.consumer = consumer;
    }
    initUFO() {
        if ((0, $dtuCc.getAppName)() !== (0, $dtuCc.AppNames).STANDALONE_DIRECTORY) return;
        (0, $fPkg5.payloadPublisher).setup({
            gasv3: this.analyticsWebClient,
            product: 'people',
            app: {
                // @ts-ignore
                version: {
                    web: __VERSION__
                }
            },
            region: (0, $96X1W.getEnv)()
        });
    // import { ufologger } from @atlassian/ufo and uncomment the following line to see UFO logs:
    // ufologger.enable();
    }
    getAnalyticsWebClient() {
        return this.analyticsWebClient;
    }
    expTracker() {
        return this._expTracker;
    }
    sendTrackEvent(eventData) {
        this.analyticsWebClient.sendTrackEvent(eventData);
    }
    /**
   * Checks whether the library has been initialized and decides whether the event should be sent or cached
   * @param {*} eventType Values could be 'track', 'screen', 'operation, 'ui'
   * @param {*} eventData Data of the event
   * @param {Function} cb Callback is called when the event is sent successfully.
   */ canEventBeSent(eventType, eventData, cb) {
        if (this.state.isReadyToSend) return true;
        // add to `pendingEventsQueue` in order to send the event later
        this.state.pendingEventsQueue.push({
            eventType: eventType,
            eventData: eventData,
            // `eventCallback` is called when `pendingEventsQueue` is processed and eventData is sent
            eventCallback: cb
        });
        return false;
    }
    pushTrackEvent(eventData, cb) {
        if (this.canEventBeSent('track', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendTrackEvent(event, cb);
        }
    }
    pushUIEvent(eventData, cb) {
        if (this.canEventBeSent('ui', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendUIEvent(event, cb);
        }
    }
    pushOperationalEvent(eventData, cb) {
        if (this.canEventBeSent('operation', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendOperationalEvent(event, cb);
        }
    }
    pushScreenEvent(eventData, cb) {
        const additionalAttributes = (0, $akp1l.default).get();
        (0, $akp1l.default).markUsed();
        if (eventData && additionalAttributes) eventData = {
            ...eventData,
            attributes: {
                ...additionalAttributes,
                ...eventData.attributes
            }
        };
        if (this.canEventBeSent('screen', eventData, cb)) this.analyticsWebClient.sendScreenEvent(eventData, cb);
    }
    buildEventPayload(eventData) {
        const attributes = this.teamId || this.consumer || eventData.attributes ? {
            ...this.teamId && {
                teamId: this.teamId
            },
            ...this.consumer && {
                consumer: this.consumer
            },
            ...eventData.attributes
        } : null;
        return {
            containerType: null,
            containerId: null,
            objectType: null,
            objectId: null,
            source: null,
            actionSubject: null,
            action: null,
            actionSubjectId: null,
            tags: [],
            ...eventData,
            attributes: attributes
        };
    }
    mapAnalyticsKeyToEvent(analyticsKey) {
        return (0, $56jml.analyticsKeyToEventMap)[analyticsKey] || null;
    }
    /**
   *  Start up E-MAU events in the new analytics pipeline (GAS v3)
   *  See: https://extranet.atlassian.com/display/BPO/DACI%3A+E-MAU+Definition
   */ async startUIViewedEvent(principalUserId) {
        if (!principalUserId) return;
        this.analyticsWebClient.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, this.cloudId || '');
        this.analyticsWebClient.setUserInfo((0, $l7jo6.userType).ATLASSIAN_ACCOUNT, principalUserId);
        this.analyticsWebClient.startUIViewedEvent();
        this.state.isReadyToSend = true;
        this.flushPendingEventsQueue();
    }
    /**
   * Flush all the pending events in the queue
   */ flushPendingEventsQueue() {
        this.state.pendingEventsQueue.forEach((element)=>{
            const { eventType: eventType, eventData: eventData, eventCallback: eventCallback } = element;
            switch(eventType){
                case 'track':
                    this.pushTrackEvent(eventData, eventCallback);
                    break;
                case 'ui':
                    this.pushUIEvent(eventData, eventCallback);
                    break;
                case 'screen':
                    this.pushScreenEvent(eventData, eventCallback);
                    break;
                case 'operation':
                    this.pushOperationalEvent(eventData, eventCallback);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.error('Invalide Event :', element);
                    break;
            }
        });
    }
    constructor(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, { commonProperties: commonProperties = {}, eventPrefix: eventPrefix = 'atlassian.people', subproduct: subproduct = $0e260035dadfd7bc$var$SUB_PRODUCT_DEFAULT, cloudId: cloudId = '' } = {}){
        this.cloudId = void 0;
        this.teamId = void 0;
        this.consumer = void 0;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.commonProperties = void 0;
        this.eventPrefix = void 0;
        this.state = void 0;
        // disabled because of linting error that upon fixing, breaks the typing
        // @ts-ignore
        this.analyticsWebClient = void 0;
        this._expTracker = void 0;
        const customOptions = {
            commonProperties: commonProperties,
            eventPrefix: eventPrefix
        };
        this.cloudId = cloudId;
        this.commonProperties = customOptions.commonProperties;
        this.eventPrefix = customOptions.eventPrefix;
        this.state = {
            analyticsscheme: $0e260035dadfd7bc$var$analyticsConfig.scheme,
            analyticsserver: $0e260035dadfd7bc$var$analyticsConfig.server,
            server: $0e260035dadfd7bc$var$getServerName(),
            product: $0e260035dadfd7bc$var$PRODUCT_DEFAULT,
            isReadyToSend: false,
            pendingEventsQueue: [],
            storage_key: 'atlassian.people.analytics',
            ...options
        };
        // New GAS pipeline client
        this.analyticsWebClient = new (0, $NF6kd.default)({
            env: $0e260035dadfd7bc$var$getEnvType((0, $96X1W.getEnv)()),
            product: 'people',
            subproduct: subproduct
        }, {});
        this.initUFO();
        this._expTracker = (0, $gLv2X.configureNewTracker)(this, this.analyticsWebClient);
    }
}
var $0e260035dadfd7bc$export$2e2bcd8739ae039 = $0e260035dadfd7bc$var$AnalyticsClient;
let $0e260035dadfd7bc$var$preservedAnaylticsClient;
const $0e260035dadfd7bc$export$fde53e78fd93a54d = ({ mode: mode, subproduct: subproduct, cloudId: cloudId })=>{
    if (!cloudId) return;
    if ($0e260035dadfd7bc$var$preservedAnaylticsClient) return $0e260035dadfd7bc$var$preservedAnaylticsClient;
    $0e260035dadfd7bc$var$preservedAnaylticsClient = new $0e260035dadfd7bc$var$AnalyticsClient({}, {
        commonProperties: {
            mode: mode
        },
        subproduct: subproduct,
        cloudId: cloudId
    });
    return $0e260035dadfd7bc$var$preservedAnaylticsClient;
};


function $4ff1b9485fefa38d$var$getAnalyticsSubproduct(appName, subProduct) {
    if (!subProduct) return appName;
    return `jira-${subProduct}-directory`;
}
const $4ff1b9485fefa38d$export$bcd55e98e7c6e45e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSetupAnalyticsClient(cloudId, appName, subProduct) {
    const $ = (0, $bDgLe.c)(12);
    let t0;
    if ($[0] !== appName || $[1] !== subProduct) {
        t0 = $4ff1b9485fefa38d$var$getAnalyticsSubproduct(appName, subProduct);
        $[0] = appName;
        $[1] = subProduct;
        $[2] = t0;
    } else t0 = $[2];
    const analyticsSubProduct = t0;
    let t1;
    if ($[3] !== analyticsSubProduct || $[4] !== appName || $[5] !== cloudId) {
        t1 = (0, $0e260035dadfd7bc$export$fde53e78fd93a54d)({
            mode: appName,
            subproduct: analyticsSubProduct,
            cloudId: cloudId
        });
        $[3] = analyticsSubProduct;
        $[4] = appName;
        $[5] = cloudId;
        $[6] = t1;
    } else t1 = $[6];
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[7] !== analyticsSubProduct || $[8] !== appName || $[9] !== cloudId) {
        t2 = ()=>{
            if (!cloudId) return;
            const analytics = (0, $0e260035dadfd7bc$export$fde53e78fd93a54d)({
                mode: appName,
                subproduct: analyticsSubProduct,
                cloudId: cloudId
            });
            setAnalyticsClient(analytics);
        };
        t3 = [
            cloudId,
            analyticsSubProduct,
            appName
        ];
        $[7] = analyticsSubProduct;
        $[8] = appName;
        $[9] = cloudId;
        $[10] = t2;
        $[11] = t3;
    } else {
        t2 = $[10];
        t3 = $[11];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return cloudId ? analyticsClient : undefined;
} : function useSetupAnalyticsClient(cloudId, appName, subProduct) {
    const analyticsSubProduct = (0, $cozmU.useMemo)(()=>$4ff1b9485fefa38d$var$getAnalyticsSubproduct(appName, subProduct), [
        appName,
        subProduct
    ]);
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)((0, $0e260035dadfd7bc$export$fde53e78fd93a54d)({
        mode: appName,
        subproduct: analyticsSubProduct,
        cloudId: cloudId
    }));
    // setup analytics object
    (0, $cozmU.useEffect)(()=>{
        if (!cloudId) return;
        const analytics = (0, $0e260035dadfd7bc$export$fde53e78fd93a54d)({
            mode: appName,
            subproduct: analyticsSubProduct,
            cloudId: cloudId
        });
        setAnalyticsClient(analytics);
    }, [
        cloudId,
        analyticsSubProduct,
        appName
    ]);
    // TODO: fix-me - currently, cloudId is required to render People app.
    // When analytics client without cloud id is used, Cypress test `dev-packages/cypress/src/specs/analytics.spec.ts` is flaky.
    // It seems that the analytics client without cloud id used first, then analytics client with cloud is replaced, but the app does not re-render in Cypress tests.
    return cloudId ? analyticsClient : undefined;
};
module.exports["useSetupAnalyticsClient"] = $4ff1b9485fefa38d$export$bcd55e98e7c6e45e;

});

parcelRegister("gLv2X", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $boaiH = parcelRequire("boaiH");


var $dtuCc = parcelRequire("dtuCc");
const $f7c72f413487fea1$export$28456d095a642fd = 'internal.browse-users-allowed';



var $56jml = parcelRequire("56jml");


var $957l5 = parcelRequire("957l5");


var $bOTdu = parcelRequire("bOTdu");

function $7bb7f62f62ed16ca$export$54c7ecd74762af6a(analytics, analyticsNext) {
    const tracker = new $7bb7f62f62ed16ca$var$DirectoryExperienceTracker({
        isNetworkOfflineError: $7bb7f62f62ed16ca$export$476aa014e2fd89d5
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = $7bb7f62f62ed16ca$var$computePerformanceAttributes(event);
            const errorAttributes = $7bb7f62f62ed16ca$var$computeErrorAttributes(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: (0, $dtuCc.getAppName)() === (0, $dtuCc.AppNames).STANDALONE_DIRECTORY,
                hasBrowseUsersPermission: (0, $957l5.isFlagEnabled)((0, $f7c72f413487fea1$export$28456d095a642fd))
            });
            const actionSubject = $7bb7f62f62ed16ca$var$sanitiseExperienceName(event.name);
            if ((0, $iDrrr.fg)('ptc-enable-ptc-common-analytics-refactor')) analyticsNext.sendOperationalEvent({
                source: (0, $56jml.AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: actionSubject,
                action: event.action,
                attributes: finalErrorDetails
            });
            else analytics.pushOperationalEvent({
                source: (0, $56jml.AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: actionSubject,
                action: event.action,
                attributes: finalErrorDetails
            });
        }
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('unload', ()=>{
        tracker.abort({
            reason: 'Abort due to Window unloading',
            attributes: {
                cause: 'WINDOW_UNLOAD'
            }
        });
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('pagehide', ()=>{
        tracker.abort({
            reason: 'Window unloading',
            attributes: {
                cause: 'PAGE_HIDE'
            }
        });
    });
    return tracker;
}
function $7bb7f62f62ed16ca$var$sanitiseExperienceName(name) {
    return name.replace(/[\/-]/g, '_');
}
function $7bb7f62f62ed16ca$var$computeErrorAttributes(event) {
    const attributes = {};
    if (event.action === 'taskFail' && event.error) {
        attributes.failError = event.error.message;
        attributes.traceId = event.error.traceId ?? null;
    }
    if (event.action === 'taskAbort' && event.reason) attributes.abortReason = event.reason;
    return attributes;
}
// compute sloSatisfied: true/false based on the latencySlo attribute
// for monitoring in SignalFx
function $7bb7f62f62ed16ca$var$computePerformanceAttributes(event) {
    if (event.action === 'taskStart') return {};
    const duration = event.duration;
    const latencySlo = event.attributes && event.attributes['latencySlo'];
    if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
    return {
        sloSatisfied: duration <= latencySlo,
        taskDuration: duration,
        latencySlo: latencySlo
    };
}
class $7bb7f62f62ed16ca$var$DirectoryExperienceTracker extends (0, $boaiH.ExperienceTracker) {
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if ((0, $bOTdu.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $bOTdu.isErrorStatusCode)((0, $bOTdu.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        const reason = (0, $bOTdu.ignoredErrorReason)(error);
        if (reason) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: reason,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    constructor(options){
        super(options);
    }
}
function $7bb7f62f62ed16ca$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    // @ts-ignore
    !!(error['graphQLErrors'] && error['networkError']));
}
module.exports["configureNewTracker"] = $7bb7f62f62ed16ca$export$54c7ecd74762af6a;
module.exports["isNetworkError"] = $7bb7f62f62ed16ca$export$476aa014e2fd89d5;

});

parcelRegister("957l5", function(module, exports) {

var $jVEhV = parcelRequire("jVEhV");


var $96X1W = parcelRequire("96X1W");


var $1P2f3 = parcelRequire("1P2f3");

var $75624a2c95788e95$export$df35587a8f95f16f = /*#__PURE__*/ function(FeatureFlag) {
    //Teams in JSM Ops productFeatureFlags
    FeatureFlag["EVENT_ON_CALL_EFF"] = "event-on-call-consolidation_s97c8";
    FeatureFlag["EVENT_ON_CALL_CONSOLIDATION_STATE"] = "event-on-call-consolidation-state";
    // Control for Open Sites permissions check
    FeatureFlag["ENABLE_MOCK_OPEN_SITES_FAIL"] = "ptc-directory-ui.deny-open-sites-in-fe";
    // Atlas
    FeatureFlag["DISABLE_ATLAS_CROSSWFLOW_ADS"] = "disable_atlas_crossflow_ads";
    return FeatureFlag;
}({});
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
const $75624a2c95788e95$var$DEFAULT_FEATURE_FLAGS = {
    ["ptc-directory-ui.deny-open-sites-in-fe"]: false,
    ["disable_atlas_crossflow_ads"]: false,
    ["event-on-call-consolidation_s97c8"]: false,
    ["event-on-call-consolidation-state"]: false
};
// Overrides only for local/CI environments
const $75624a2c95788e95$var$LOCAL_OVERRIDE_FEATURE_FLAGS = {
};
const $75624a2c95788e95$export$7101ae34ef1f53be = ()=>$1P2f3?.env?.NODE_ENV === 'development' || (0, $96X1W.getEnv)() === 'local' ? {
        ...$75624a2c95788e95$var$DEFAULT_FEATURE_FLAGS,
        ...$75624a2c95788e95$var$LOCAL_OVERRIDE_FEATURE_FLAGS
    } : {
        ...$75624a2c95788e95$var$DEFAULT_FEATURE_FLAGS
    };
function $75624a2c95788e95$export$ba72073d757a1bc2(flag) {
    return (0, $jVEhV.isFlagEnabled)(flag);
}
module.exports["FeatureFlag"] = $75624a2c95788e95$export$df35587a8f95f16f;
module.exports["isFlagEnabled"] = $75624a2c95788e95$export$ba72073d757a1bc2;

});

parcelRegister("akp1l", function(module, exports) {
/**
 * A singleton module that will store a referrer data in a closure
 * and retrieve that data in an analytics client untill the app has
 * a route transition happened.
 *
 * How it works:
 * 1. whenever we init our app with `src` or `ref` in the URL we gonna preserve them here
 * 2. in every screen event we gonna retrieve `src` and `ref` and add them to event attributes
 * 3. as soon as app transitions to any other route we gonna cleanup the stored referrer data
 *    to stop tracking it further.
 *
 * Notes:
 *  Due to how `referrerInfo` is used to store data temporarily, now it is used only at 2 places:
 * - Analytic Client `packages/common/src/clients/analytics-client.ts`
 * - RecordTransition `packages/embeddable-directory/src/components/RecordTransition/RecordTransition.tsx`
 * If other codes try to access value inside `referrerInfo`, they may access old/empty data.
 */ 
var $kuWSC = parcelRequire("kuWSC");

// the storage for our referrer info;
let $cd8d784b6ff9c00e$var$data = null;
const $cd8d784b6ff9c00e$var$referrerInfo = {
    // as we preserving the data, we should at least get it once to record in analytics before allowing cleanup
    isUsed: false,
    markUsed () {
        $cd8d784b6ff9c00e$var$referrerInfo.isUsed = true;
    },
    get () {
        return $cd8d784b6ff9c00e$var$data;
    },
    set ({ src: src = '', ref: ref = '' }) {
        // clean up strings
        $cd8d784b6ff9c00e$var$data = {
            src: (0, $kuWSC.sanitiseValue)(src || '', {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            }),
            ref: (0, $kuWSC.sanitiseValue)(ref, {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            })
        };
    },
    cleanup (force) {
        if (!$cd8d784b6ff9c00e$var$referrerInfo.isUsed && !force) return;
        $cd8d784b6ff9c00e$var$data = null;
    }
};
var $cd8d784b6ff9c00e$export$2e2bcd8739ae039 = $cd8d784b6ff9c00e$var$referrerInfo;
module.exports["default"] = $cd8d784b6ff9c00e$export$2e2bcd8739ae039;

});

parcelRegister("kuWSC", function(module, exports) {
const $f84c3d36ea094eac$var$FORBIDDEN_CODE_CHARS = [
    8207 // https://www.fileformat.info/info/unicode/char/200f/index.htm
];
function $f84c3d36ea094eac$export$b66eb39ba856053f(value, options = {}) {
    let trimmedStr = value.trim();
    $f84c3d36ea094eac$var$FORBIDDEN_CODE_CHARS.forEach((codeChar)=>{
        const char = String.fromCharCode(codeChar);
        const re = new RegExp(char, 'gm');
        trimmedStr = trimmedStr.replace(re, '');
    });
    if (options.shouldHaveSafeCharsOnly) {
        trimmedStr = trimmedStr.replace(/[^a-z0-9_-]/gim, '');
        trimmedStr = trimmedStr.trim();
    }
    if (options.shouldEncode) trimmedStr = encodeURIComponent(trimmedStr);
    return trimmedStr;
}
module.exports["sanitiseValue"] = $f84c3d36ea094eac$export$b66eb39ba856053f;

});

parcelRegister("jnFfl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bG29P = parcelRequire("bG29P");


var $eOw0I = parcelRequire("eOw0I");

const $c19a76a8d19add47$export$5cf469f83bcf3f9e = '/gateway/api/permissions/permitted';
const $c19a76a8d19add47$export$fcd6a587480f569c = (cloudId)=>({
        permissionId: 'write',
        resourceId: `ari:cloud:jira::site/${cloudId}`
    });
const $c19a76a8d19add47$export$46f584bffbc74fe = (cloudId)=>cloudId ? (0, $eOw0I.requestWithAbort)($c19a76a8d19add47$export$5cf469f83bcf3f9e, {
        body: JSON.stringify($c19a76a8d19add47$export$fcd6a587480f569c(cloudId))
    }) : [
        ()=>Promise.resolve(new Response()),
        new AbortController()
    ];


const $822d1bf44794ab03$export$3847702755d66eb8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cloudId, options)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] !== cloudId) {
        t0 = (0, $c19a76a8d19add47$export$46f584bffbc74fe)(cloudId);
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const [request, controller] = t0;
    const t1 = options?.initialState;
    let t2;
    if ($[2] !== t1) {
        t2 = {
            initialState: {
                ...t1
            }
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const [getJiraCheck, result] = (0, $bG29P.useLazyService)(request, controller, t2);
    const t3 = Boolean(result.data?.permitted);
    let t4;
    if ($[4] !== result || $[5] !== t3) {
        t4 = {
            ...result,
            isJiraAvailable: t3
        };
        $[4] = result;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== getJiraCheck || $[8] !== t4) {
        t5 = [
            getJiraCheck,
            t4
        ];
        $[7] = getJiraCheck;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : (cloudId, options)=>{
    const [request, controller] = (0, $cozmU.useMemo)(()=>(0, $c19a76a8d19add47$export$46f584bffbc74fe)(cloudId), [
        cloudId
    ]);
    const [getJiraCheck, result] = (0, $bG29P.useLazyService)(request, controller, {
        initialState: {
            ...options?.initialState
        }
    });
    return [
        getJiraCheck,
        {
            ...result,
            isJiraAvailable: Boolean(result.data?.permitted)
        }
    ];
};
const $822d1bf44794ab03$export$b998d6ed276aaffa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (...t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const [cloudId, options] = t0;
    const [getJiraCheck, result] = $822d1bf44794ab03$export$3847702755d66eb8(cloudId, options);
    let t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== getJiraCheck) {
        t1 = ()=>{
            if (cloudId) getJiraCheck();
        };
        t2 = [
            cloudId,
            getJiraCheck
        ];
        $[0] = cloudId;
        $[1] = getJiraCheck;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return result;
} : (...[cloudId, options])=>{
    const [getJiraCheck, result] = $822d1bf44794ab03$export$3847702755d66eb8(cloudId, options);
    (0, $cozmU.useEffect)(()=>{
        if (cloudId) getJiraCheck();
    }, [
        cloudId,
        getJiraCheck
    ]);
    return result;
};
module.exports["useJiraCheckService"] = $822d1bf44794ab03$export$b998d6ed276aaffa;

});

parcelRegister("bG29P", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eOw0I = parcelRequire("eOw0I");

const $cea2504a54ef7fbd$export$1a85343b4dbf3bf5 = (...[request, controller, options])=>{
    const [state, setState] = (0, $cozmU.useState)({
        loading: false,
        error: undefined,
        data: undefined,
        ...options?.initialState
    });
    const getData = (0, $cozmU.useCallback)(async ()=>{
        setState((s)=>({
                ...s,
                loading: true
            }));
        try {
            const response = await request();
            const traceId = response?.headers?.get('atl-traceid');
            let jsonResponse;
            let isResponseText = false;
            const resText = await response?.text() || '{}';
            try {
                jsonResponse = JSON.parse(resText);
            } catch  {
                isResponseText = true;
            }
            if (!response?.ok || isResponseText) {
                if (options?.ErrorHandler) throw new options.ErrorHandler({
                    ...jsonResponse,
                    traceId: traceId,
                    status: response?.status,
                    statusText: response?.statusText || resText
                });
                else throw new (0, $eOw0I.HttpError)(response?.status, response?.statusText || resText, traceId);
            }
            setState((s_1)=>({
                    ...s_1,
                    loading: false,
                    data: jsonResponse
                }));
            return response;
        } catch (error) {
            setState((s_0)=>({
                    ...s_0,
                    loading: false,
                    error: error
                }));
        }
    }, [
        request,
        options?.ErrorHandler
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            controller.abort();
        };
    }, [
        controller
    ]);
    return [
        getData,
        state
    ];
};
const $cea2504a54ef7fbd$export$6de4685a6c88b4e9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (...t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const [request, controller, options] = t0;
    const t1 = options?.initialState;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            ...t1,
            loading: true
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== options || $[3] !== t2) {
        t3 = {
            ...options,
            initialState: t2
        };
        $[2] = options;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const [getData, state] = $cea2504a54ef7fbd$export$1a85343b4dbf3bf5(request, controller, t3);
    let t4;
    let t5;
    if ($[5] !== getData) {
        t4 = ()=>{
            getData();
        };
        t5 = [
            getData
        ];
        $[5] = getData;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $cozmU.useEffect)(t4, t5);
    return state;
} : (...[request, controller, options])=>{
    const [getData, state] = $cea2504a54ef7fbd$export$1a85343b4dbf3bf5(request, controller, {
        ...options,
        initialState: {
            ...options?.initialState,
            loading: true
        }
    });
    (0, $cozmU.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return state;
};
const $cea2504a54ef7fbd$export$fb699d9076441ae7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (request, t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const initialState = t1;
    let t2;
    if ($[2] !== initialState) {
        t2 = {
            loading: false,
            ...initialState
        };
        $[2] = initialState;
        $[3] = t2;
    } else t2 = $[3];
    const [state, setStateRaw] = (0, $cozmU.useState)(t2);
    const isMounted = (0, $cozmU.useRef)(true);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        };
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t3);
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (state_0)=>{
            if (isMounted.current) setStateRaw(state_0);
        };
        $[5] = t4;
    } else t4 = $[5];
    const setState = t4;
    let t5;
    if ($[6] !== request) {
        t5 = async ()=>{
            setState({
                loading: true,
                error: undefined,
                data: undefined
            });
            try {
                const data = await request();
                setState({
                    loading: false,
                    error: undefined,
                    data: data
                });
            } catch (t6) {
                const error = t6;
                setState({
                    loading: false,
                    error: error,
                    data: undefined
                });
            }
        };
        $[6] = request;
        $[7] = t5;
    } else t5 = $[7];
    const fetchData = t5;
    let t6;
    if ($[8] !== fetchData || $[9] !== state) {
        t6 = {
            ...state,
            fetchData: fetchData
        };
        $[8] = fetchData;
        $[9] = state;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $cozmU.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $cozmU.useCallback)((state_0)=>{
        if (isMounted.current) setStateRaw(state_0);
    }, []);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};
module.exports["useLazyService"] = $cea2504a54ef7fbd$export$1a85343b4dbf3bf5;
module.exports["useService"] = $cea2504a54ef7fbd$export$6de4685a6c88b4e9;
module.exports["useServiceLight"] = $cea2504a54ef7fbd$export$fb699d9076441ae7;

});

parcelRegister("eOw0I", function(module, exports) {
class $8b506e27ed19218b$var$AbortSignalFacade {
    constructor(){
        this.aborted = false;
        this.reason = '';
        this.onabort = ()=>{};
        this.throwIfAborted = ()=>{};
        this.addEventListener = ()=>{};
        this.removeEventListener = ()=>{};
        this.dispatchEvent = ()=>false;
    }
}
class $8b506e27ed19218b$export$f5cffffa581a7d2c {
    abort() {}
    constructor(){
        this.signal = new $8b506e27ed19218b$var$AbortSignalFacade();
        if (typeof window === 'object' && window.AbortController) {
            const controller = new AbortController();
            this.abort = controller.abort.bind(controller);
            this.signal = controller.signal;
        }
    }
}


const $be89ef6d0aeccd03$export$b5fe3f66a567bec0 = (url, options = {})=>()=>fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            ...options
        });
const $be89ef6d0aeccd03$export$970d18814fa0cb04 = (url, options = {})=>{
    const controller = new (0, $8b506e27ed19218b$export$f5cffffa581a7d2c)();
    return [
        $be89ef6d0aeccd03$export$b5fe3f66a567bec0(url, {
            signal: controller.signal,
            ...options
        }),
        controller
    ];
};
class $be89ef6d0aeccd03$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = void 0;
        this.traceId = void 0;
        this.code = code;
        this.traceId = traceId;
    }
}
module.exports["requestWithAbort"] = $be89ef6d0aeccd03$export$970d18814fa0cb04;
module.exports["HttpError"] = $be89ef6d0aeccd03$export$65bd6083489bd8bb;

});

parcelRegister("1DL82", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $2tuSz = parcelRequire("2tuSz");


var $hojDG = parcelRequire("hojDG");











var $6eflU = parcelRequire("6eflU");

const $a42aee329d6d28f6$export$e30f49f36a0eeaeb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isSentryEnabled, config)=>{
    const $ = (0, $bDgLe.c)(7);
    const [sentryInitialised, setSentryInitialised] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] !== config || $[1] !== isSentryEnabled || $[2] !== sentryInitialised) {
        t0 = async ()=>{
            if (!sentryInitialised && isSentryEnabled && !(0, $6eflU.sentryClient)) await (0, $6eflU.setupSentryClient)(config);
        };
        $[0] = config;
        $[1] = isSentryEnabled;
        $[2] = sentryInitialised;
        $[3] = t0;
    } else t0 = $[3];
    const setupSentry = t0;
    let t1;
    let t2;
    if ($[4] !== setupSentry) {
        t1 = ()=>{
            setupSentry().then(()=>setSentryInitialised(true));
        };
        t2 = [
            setupSentry
        ];
        $[4] = setupSentry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return 0, $6eflU.sentryClient;
} : (isSentryEnabled, config)=>{
    const [sentryInitialised, setSentryInitialised] = (0, $cozmU.useState)(false);
    const setupSentry = (0, $cozmU.useCallback)(async ()=>{
        if (!sentryInitialised && isSentryEnabled && !(0, $6eflU.sentryClient)) await (0, $6eflU.setupSentryClient)(config);
    }, [
        config,
        isSentryEnabled,
        sentryInitialised
    ]);
    (0, $cozmU.useEffect)(()=>{
        setupSentry().then(()=>setSentryInitialised(true));
    }, [
        setupSentry
    ]);
    return 0, $6eflU.sentryClient;
};



var $8mQ4z = parcelRequire("8mQ4z");

















var $24Rm0 = parcelRequire("24Rm0");

const $1f454174cb36bcbc$export$38de4dc070d8bd7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (embedConfig)=>{
    const $ = (0, $bDgLe.c)(4);
    const { setEmbedConfig: setEmbedConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    let t0;
    let t1;
    if ($[0] !== embedConfig || $[1] !== setEmbedConfig) {
        t0 = ()=>{
            setEmbedConfig(embedConfig);
        };
        t1 = [
            setEmbedConfig,
            embedConfig
        ];
        $[0] = embedConfig;
        $[1] = setEmbedConfig;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (embedConfig)=>{
    const { setEmbedConfig: setEmbedConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    (0, $cozmU.useEffect)(()=>{
        setEmbedConfig(embedConfig);
    }, [
        setEmbedConfig,
        embedConfig
    ]);
};





















var $dZPDC = parcelRequire("dZPDC");


var $aEO8E = parcelRequire("aEO8E");

const $f340ed9ec6140e6c$export$50a3d4f5c944b117 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (stargateRoot, cloudId, orgId, principalUserId)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== cloudId || $[1] !== orgId || $[2] !== principalUserId || $[3] !== stargateRoot) {
        t0 = {
            stargateRoot: stargateRoot,
            cloudId: cloudId,
            orgId: orgId,
            principalUserId: principalUserId
        };
        $[0] = cloudId;
        $[1] = orgId;
        $[2] = principalUserId;
        $[3] = stargateRoot;
        $[4] = t0;
    } else t0 = $[4];
    $f340ed9ec6140e6c$export$5eae9f59196893ac(t0);
} : (stargateRoot, cloudId, orgId, principalUserId)=>{
    $f340ed9ec6140e6c$export$5eae9f59196893ac({
        stargateRoot: stargateRoot,
        cloudId: cloudId,
        orgId: orgId,
        principalUserId: principalUserId
    });
};
const $f340ed9ec6140e6c$export$5eae9f59196893ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { stargateRoot: stargateRoot, cloudId: cloudId, orgId: orgId, principalUserId: principalUserId } = t0;
    const [isClientReady, setIsClientReady] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== stargateRoot) {
        t1 = ()=>{
            if (!stargateRoot) return;
            (0, $dZPDC.teamsClient).setBaseUrl(stargateRoot);
        };
        t2 = [
            stargateRoot
        ];
        $[0] = stargateRoot;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== cloudId || $[4] !== orgId || $[5] !== principalUserId) {
        t3 = ()=>{
            (0, $dZPDC.teamsClient).setContext({
                cloudId: cloudId,
                orgId: orgId,
                userId: principalUserId
            });
            if (!orgId) (0, $aEO8E.logInfoMessage)("No orgId set - useTeamsClientSetup", {
                cloudId: cloudId
            });
            setIsClientReady(true);
        };
        t4 = [
            cloudId,
            orgId,
            principalUserId
        ];
        $[3] = cloudId;
        $[4] = orgId;
        $[5] = principalUserId;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[8] !== cloudId || $[9] !== orgId || $[10] !== principalUserId || $[11] !== stargateRoot) {
        t5 = ()=>{
            if (!stargateRoot) return;
            (0, $dZPDC.teamsClient).setTeamCentralContext(stargateRoot, {
                cloudId: cloudId,
                orgId: orgId,
                userId: principalUserId
            });
        };
        t6 = [
            cloudId,
            orgId,
            principalUserId,
            stargateRoot
        ];
        $[8] = cloudId;
        $[9] = orgId;
        $[10] = principalUserId;
        $[11] = stargateRoot;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[14] !== isClientReady) {
        t7 = {
            isClientReady: isClientReady
        };
        $[14] = isClientReady;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
} : ({ stargateRoot: stargateRoot, cloudId: cloudId, orgId: orgId, principalUserId: principalUserId })=>{
    const [isClientReady, setIsClientReady] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!stargateRoot) return;
        (0, $dZPDC.teamsClient).setBaseUrl(stargateRoot);
    }, [
        stargateRoot
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $dZPDC.teamsClient).setContext({
            cloudId: cloudId,
            orgId: orgId,
            userId: principalUserId
        });
        if (!orgId) (0, $aEO8E.logInfoMessage)(`No orgId set - useTeamsClientSetup`, {
            cloudId: cloudId
        });
        // Mark client as ready after context is set
        setIsClientReady(true);
    }, [
        cloudId,
        orgId,
        principalUserId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!stargateRoot) return;
        (0, $dZPDC.teamsClient).setTeamCentralContext(stargateRoot, {
            cloudId: cloudId,
            orgId: orgId,
            userId: principalUserId
        });
    }, [
        cloudId,
        orgId,
        principalUserId,
        stargateRoot
    ]);
    return {
        isClientReady: isClientReady
    };
};





const $cce5f094c6e55f8d$export$2f68760d90a1443f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (clientConfig)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setClientConfig: setClientConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    let t0;
    if ($[0] !== clientConfig.cloudId || $[1] !== clientConfig.orgId || $[2] !== clientConfig.principalUserId || $[3] !== clientConfig.stargateRoot) {
        t0 = {
            stargateRoot: clientConfig.stargateRoot,
            cloudId: clientConfig.cloudId,
            orgId: clientConfig.orgId,
            principalUserId: clientConfig.principalUserId
        };
        $[0] = clientConfig.cloudId;
        $[1] = clientConfig.orgId;
        $[2] = clientConfig.principalUserId;
        $[3] = clientConfig.stargateRoot;
        $[4] = t0;
    } else t0 = $[4];
    const { isClientReady: isClientReady } = (0, $f340ed9ec6140e6c$export$5eae9f59196893ac)(t0);
    let t1;
    let t2;
    if ($[5] !== clientConfig || $[6] !== setClientConfig) {
        t1 = ()=>{
            setClientConfig(clientConfig);
        };
        t2 = [
            setClientConfig,
            clientConfig
        ];
        $[5] = clientConfig;
        $[6] = setClientConfig;
        $[7] = t1;
        $[8] = t2;
    } else {
        t1 = $[7];
        t2 = $[8];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[9] !== isClientReady) {
        t3 = {
            isClientReady: isClientReady
        };
        $[9] = isClientReady;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (clientConfig)=>{
    const { setClientConfig: setClientConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    const { isClientReady: isClientReady } = (0, $f340ed9ec6140e6c$export$5eae9f59196893ac)({
        stargateRoot: clientConfig.stargateRoot,
        cloudId: clientConfig.cloudId,
        orgId: clientConfig.orgId,
        principalUserId: clientConfig.principalUserId
    });
    (0, $cozmU.useEffect)(()=>{
        setClientConfig(clientConfig);
    }, [
        setClientConfig,
        clientConfig
    ]);
    return {
        isClientReady: isClientReady
    };
};














const $8d7342ec328baa61$export$254030771a907fca = (0, $gtMdU.isReactCompilerActivePlatform)() ? (config)=>{
    const $ = (0, $bDgLe.c)(4);
    const { setNavigationConfig: setNavigationConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    let t0;
    let t1;
    if ($[0] !== config || $[1] !== setNavigationConfig) {
        t0 = ()=>{
            setNavigationConfig(config);
        };
        t1 = [
            setNavigationConfig,
            config
        ];
        $[0] = config;
        $[1] = setNavigationConfig;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (config)=>{
    const { setNavigationConfig: setNavigationConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    (0, $cozmU.useEffect)(()=>{
        setNavigationConfig(config);
    }, [
        setNavigationConfig,
        config
    ]);
};














const $b2f04776acb0e3d0$export$dfa1b62b4df4bab3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (teamsPreviewPanelConfig)=>{
    const $ = (0, $bDgLe.c)(4);
    const { setTeamsPreviewPanelConfig: setTeamsPreviewPanelConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    let t0;
    let t1;
    if ($[0] !== setTeamsPreviewPanelConfig || $[1] !== teamsPreviewPanelConfig) {
        t0 = ()=>{
            setTeamsPreviewPanelConfig(teamsPreviewPanelConfig);
        };
        t1 = [
            setTeamsPreviewPanelConfig,
            teamsPreviewPanelConfig
        ];
        $[0] = setTeamsPreviewPanelConfig;
        $[1] = teamsPreviewPanelConfig;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (teamsPreviewPanelConfig)=>{
    const { setTeamsPreviewPanelConfig: setTeamsPreviewPanelConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    (0, $cozmU.useEffect)(()=>{
        setTeamsPreviewPanelConfig(teamsPreviewPanelConfig);
    }, [
        setTeamsPreviewPanelConfig,
        teamsPreviewPanelConfig
    ]);
};














const $973f98f7c9f24c80$export$f8296902b02e4ba1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (teamsProductConfig)=>{
    const $ = (0, $bDgLe.c)(4);
    const { setTeamsProductConfig: setTeamsProductConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    let t0;
    let t1;
    if ($[0] !== setTeamsProductConfig || $[1] !== teamsProductConfig) {
        t0 = ()=>{
            setTeamsProductConfig(teamsProductConfig);
        };
        t1 = [
            setTeamsProductConfig,
            teamsProductConfig
        ];
        $[0] = setTeamsProductConfig;
        $[1] = teamsProductConfig;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (teamsProductConfig)=>{
    const { setTeamsProductConfig: setTeamsProductConfig } = (0, $24Rm0.useSetTeamsConfigActions)();
    (0, $cozmU.useEffect)(()=>{
        setTeamsProductConfig(teamsProductConfig);
    }, [
        setTeamsProductConfig,
        teamsProductConfig
    ]);
};


const $dc5b807050ac4650$export$338e93cfada2e9d7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (appConfig)=>{
    const $ = (0, $bDgLe.c)(23);
    let t0;
    if ($[0] !== appConfig.cloudId || $[1] !== appConfig.env || $[2] !== appConfig.orgId || $[3] !== appConfig.principalUserId || $[4] !== appConfig.stargateRoot) {
        t0 = {
            cloudId: appConfig.cloudId,
            stargateRoot: appConfig.stargateRoot,
            env: appConfig.env,
            orgId: appConfig.orgId,
            principalUserId: appConfig.principalUserId
        };
        $[0] = appConfig.cloudId;
        $[1] = appConfig.env;
        $[2] = appConfig.orgId;
        $[3] = appConfig.principalUserId;
        $[4] = appConfig.stargateRoot;
        $[5] = t0;
    } else t0 = $[5];
    const { isClientReady: isClientReady } = (0, $cce5f094c6e55f8d$export$2f68760d90a1443f)(t0);
    let t1;
    if ($[6] !== appConfig.appName || $[7] !== appConfig.isJiraAvailable || $[8] !== appConfig.locale || $[9] !== appConfig.openLinksInNewTab || $[10] !== appConfig.productFeatureFlags || $[11] !== appConfig.productName || $[12] !== appConfig.subProduct) {
        t1 = {
            appName: appConfig.appName,
            productName: appConfig.productName,
            isJiraAvailable: appConfig.isJiraAvailable,
            subProduct: appConfig.subProduct,
            locale: appConfig.locale,
            productFeatureFlags: appConfig.productFeatureFlags,
            openLinksInNewTab: appConfig.openLinksInNewTab
        };
        $[6] = appConfig.appName;
        $[7] = appConfig.isJiraAvailable;
        $[8] = appConfig.locale;
        $[9] = appConfig.openLinksInNewTab;
        $[10] = appConfig.productFeatureFlags;
        $[11] = appConfig.productName;
        $[12] = appConfig.subProduct;
        $[13] = t1;
    } else t1 = $[13];
    (0, $973f98f7c9f24c80$export$f8296902b02e4ba1)(t1);
    let t2;
    if ($[14] !== appConfig.contextEntryPoint || $[15] !== appConfig.contextSpaPaths) {
        t2 = {
            contextSpaPaths: appConfig.contextSpaPaths,
            contextEntryPoint: appConfig.contextEntryPoint
        };
        $[14] = appConfig.contextEntryPoint;
        $[15] = appConfig.contextSpaPaths;
        $[16] = t2;
    } else t2 = $[16];
    (0, $8d7342ec328baa61$export$254030771a907fca)(t2);
    let t3;
    if ($[17] !== appConfig.openPreviewPanel) {
        t3 = {
            openPreviewPanel: appConfig.openPreviewPanel
        };
        $[17] = appConfig.openPreviewPanel;
        $[18] = t3;
    } else t3 = $[18];
    (0, $b2f04776acb0e3d0$export$dfa1b62b4df4bab3)(t3);
    let t4;
    if ($[19] !== appConfig.openGiveKudosInNewTab) {
        t4 = {
            openGiveKudosInNewTab: appConfig.openGiveKudosInNewTab
        };
        $[19] = appConfig.openGiveKudosInNewTab;
        $[20] = t4;
    } else t4 = $[20];
    (0, $1f454174cb36bcbc$export$38de4dc070d8bd7)(t4);
    let t5;
    if ($[21] !== isClientReady) {
        t5 = {
            isClientReady: isClientReady
        };
        $[21] = isClientReady;
        $[22] = t5;
    } else t5 = $[22];
    return t5;
} : (appConfig)=>{
    const { isClientReady: isClientReady } = (0, $cce5f094c6e55f8d$export$2f68760d90a1443f)({
        cloudId: appConfig.cloudId,
        stargateRoot: appConfig.stargateRoot,
        env: appConfig.env,
        orgId: appConfig.orgId,
        principalUserId: appConfig.principalUserId
    });
    (0, $973f98f7c9f24c80$export$f8296902b02e4ba1)({
        appName: appConfig.appName,
        productName: appConfig.productName,
        isJiraAvailable: appConfig.isJiraAvailable,
        subProduct: appConfig.subProduct,
        locale: appConfig.locale,
        productFeatureFlags: appConfig.productFeatureFlags,
        openLinksInNewTab: appConfig.openLinksInNewTab
    });
    (0, $8d7342ec328baa61$export$254030771a907fca)({
        contextSpaPaths: appConfig.contextSpaPaths,
        contextEntryPoint: appConfig.contextEntryPoint
    });
    (0, $b2f04776acb0e3d0$export$dfa1b62b4df4bab3)({
        openPreviewPanel: appConfig.openPreviewPanel
    });
    (0, $1f454174cb36bcbc$export$38de4dc070d8bd7)({
        openGiveKudosInNewTab: appConfig.openGiveKudosInNewTab
    });
    return {
        isClientReady: isClientReady
    };
};



var $hnAeG = parcelRequire("hnAeG");











var $1Rqje = parcelRequire("1Rqje");


var $gSKQV = parcelRequire("gSKQV");

const $2323c3fe57b02e0b$export$47bd48f80e3bc7b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProfileCardClientConfigProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const profileCardClient = (0, $gSKQV.useProfileClient)();
    let t1;
    if ($[3] !== profileCardClient || $[4] !== props) {
        t1 = {
            ...props,
            profileCardClient: profileCardClient
        };
        $[3] = profileCardClient;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const config = t1;
    let t2;
    if ($[6] !== children || $[7] !== config) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Rqje.ProfileCardClientConfigContext).Provider, {
            value: config
        }, children);
        $[6] = children;
        $[7] = config;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function ProfileCardClientConfigProvider({ children: children, ...props }) {
    const profileCardClient = (0, $gSKQV.useProfileClient)();
    const config = (0, $cozmU.useMemo)(()=>({
            ...props,
            profileCardClient: profileCardClient
        }), [
        props,
        profileCardClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Rqje.ProfileCardClientConfigContext).Provider, {
        value: config
    }, children);
};


const $0848e8ec87f157cf$var$IS_LOCAL = false;
const $0848e8ec87f157cf$export$7d5cea3023a4360c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamsWrapper(t0) {
    const $ = (0, $bDgLe.c)(19);
    const { children: children, appConfig: appConfig } = t0;
    const t1 = appConfig.appName ? `${appConfig.appName}` : undefined;
    let t2;
    if ($[0] !== appConfig.env || $[1] !== t1) {
        t2 = {
            env: appConfig.env,
            appName: t1
        };
        $[0] = appConfig.env;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    (0, $a42aee329d6d28f6$export$e30f49f36a0eeaeb)(!$0848e8ec87f157cf$var$IS_LOCAL, t2);
    const { isClientReady: isClientReady } = (0, $dc5b807050ac4650$export$338e93cfada2e9d7)(appConfig);
    if (!isClientReady && (0, $iDrrr.fg)("team-profile-await-client-readiness")) return null;
    const t3 = appConfig.openLinksInNewTab ?? false;
    const t4 = appConfig.contextEntryPoint ?? undefined;
    let t5;
    if ($[3] !== appConfig.openPreviewPanel || $[4] !== appConfig.push || $[5] !== t3 || $[6] !== t4) {
        t5 = {
            forceExternalIntent: t3,
            navigate: appConfig.push,
            openPreviewPanel: appConfig.openPreviewPanel,
            contextEntryPoint: t4
        };
        $[3] = appConfig.openPreviewPanel;
        $[4] = appConfig.push;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== children) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8mQ4z.DialogProvider), null, children);
        $[8] = children;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t5 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2tuSz.TeamsAppAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hojDG.TeamsNavigationProvider), {
            value: t5
        }, t6));
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== appConfig || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2323c3fe57b02e0b$export$47bd48f80e3bc7b3), appConfig, t7);
        $[13] = appConfig;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== appConfig || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hnAeG.AppConfigProvider), appConfig, t8);
        $[16] = appConfig;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : function TeamsWrapper({ children: children, appConfig: appConfig }) {
    (0, $a42aee329d6d28f6$export$e30f49f36a0eeaeb)(!$0848e8ec87f157cf$var$IS_LOCAL, {
        env: appConfig.env,
        appName: appConfig.appName ? `${appConfig.appName}` : undefined
    });
    const { isClientReady: isClientReady } = (0, $dc5b807050ac4650$export$338e93cfada2e9d7)(appConfig);
    // Don't render children until the teams client is properly configured
    // Otherwise we make fetch requests to the client before it has context set
    if (!isClientReady && (0, $iDrrr.fg)('team-profile-await-client-readiness')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hnAeG.AppConfigProvider), appConfig, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2323c3fe57b02e0b$export$47bd48f80e3bc7b3), appConfig, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2tuSz.TeamsAppAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hojDG.TeamsNavigationProvider), {
        value: {
            forceExternalIntent: appConfig.openLinksInNewTab ?? false,
            navigate: appConfig.push,
            openPreviewPanel: appConfig.openPreviewPanel,
            contextEntryPoint: appConfig.contextEntryPoint ?? undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8mQ4z.DialogProvider), null, children)))));
};
module.exports["TeamsWrapper"] = $0848e8ec87f157cf$export$7d5cea3023a4360c;

});

parcelRegister("8mQ4z", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aRGok = parcelRequire("aRGok");


var $6r82C = parcelRequire("6r82C");

const $ee3b0dce80095f62$var$dialogProviderReducer = (state, action)=>{
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error(`Unhandled type for dialogReducer: ${action.type}`);
    }
};
const $ee3b0dce80095f62$export$b52337b35cd3c980 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose } = props;
    const { closeDialog: closeDialog } = (0, $cozmU.useContext)((0, $6r82C.DialogContext));
    if (!DialogComponent) return null;
    let t0;
    if ($[0] !== closeDialog || $[1] !== onClose) {
        t0 = ()=>{
            closeDialog();
            if (onClose) onClose();
        };
        $[0] = closeDialog;
        $[1] = onClose;
        $[2] = t0;
    } else t0 = $[2];
    const handleCloseDialog = t0;
    let t1;
    if ($[3] !== DialogComponent || $[4] !== handleCloseDialog || $[5] !== isOpen) {
        t1 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(DialogComponent, {
            onClose: handleCloseDialog
        });
        $[3] = DialogComponent;
        $[4] = handleCloseDialog;
        $[5] = isOpen;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t1);
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : (props)=>{
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose } = props;
    const { closeDialog: closeDialog } = (0, $cozmU.useContext)((0, $6r82C.DialogContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(DialogComponent, {
        onClose: handleCloseDialog
    }));
};
const $ee3b0dce80095f62$export$7ab5cfe96fae86d3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            DialogComponent: null,
            isOpen: false
        };
        $[0] = t1;
    } else t1 = $[0];
    const [dialogProviderState, dispatch] = (0, $cozmU.useReducer)($ee3b0dce80095f62$var$dialogProviderReducer, t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            openDialog: (DialogComponent)=>dispatch({
                    type: "open",
                    payload: {
                        DialogComponent: DialogComponent
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: "close"
                })
        };
        $[1] = t2;
    } else t2 = $[1];
    const value = t2;
    let t3;
    if ($[2] !== dialogProviderState) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee3b0dce80095f62$export$b52337b35cd3c980, dialogProviderState);
        $[2] = dialogProviderState;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6r82C.DialogContext).Provider, {
            value: value
        }, children, t3);
        $[4] = children;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ children: children })=>{
    const [dialogProviderState, dispatch] = (0, $cozmU.useReducer)($ee3b0dce80095f62$var$dialogProviderReducer, {
        DialogComponent: null,
        isOpen: false
    });
    const value = (0, $cozmU.useMemo)(()=>({
            openDialog: (DialogComponent)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6r82C.DialogContext).Provider, {
        value: value
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee3b0dce80095f62$export$b52337b35cd3c980, dialogProviderState));
};
module.exports["DialogProvider"] = $ee3b0dce80095f62$export$7ab5cfe96fae86d3;

});

parcelRegister("6r82C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a7f551e506b9f13a$export$8b93a07348a7730c = (0, $cozmU.createContext)({
    openDialog: ()=>null,
    closeDialog: ()=>null
});
module.exports["DialogContext"] = $a7f551e506b9f13a$export$8b93a07348a7730c;

});

parcelRegister("1Rqje", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $cace6fb3a92b54fb$var$error = new Error('ProfileCardClientConfigProvider is not found in higher components');
const $cace6fb3a92b54fb$var$defaultState = {
    addFlag: ()=>{
        // eslint-disable-next-line no-console
        console.error($cace6fb3a92b54fb$var$error);
    },
    push: ()=>{
        // eslint-disable-next-line no-console
        console.error($cace6fb3a92b54fb$var$error);
    },
    contextEntryPoint: null,
    cloudId: null
};
const $cace6fb3a92b54fb$export$c804cb3b184b670f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($cace6fb3a92b54fb$var$defaultState);
const $cace6fb3a92b54fb$export$a3c560c84e5d436d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($cace6fb3a92b54fb$export$c804cb3b184b670f);
} : ()=>(0, $cozmU.useContext)($cace6fb3a92b54fb$export$c804cb3b184b670f);
module.exports["ProfileCardClientConfigContext"] = $cace6fb3a92b54fb$export$c804cb3b184b670f;
module.exports["useProfileCardClientConfig"] = $cace6fb3a92b54fb$export$a3c560c84e5d436d;

});

parcelRegister("gSKQV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRkXe = parcelRequire("lRkXe");


var $3DKrH = parcelRequire("3DKrH");


var $f912q = parcelRequire("f912q");

const $d9451ac875294dd9$var$CACHE_MAX_AGE = 60000;
const $d9451ac875294dd9$var$actions = {
    createClient: (stargateRoot, enableTeamCentral = false, cloudId)=>({ setState: setState })=>{
            const profileClient = new (0, $lRkXe.default)({
                gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                url: `${stargateRoot}/directory/graphql`,
                teamCentralDisabled: !enableTeamCentral,
                // teamCentralBaseUrl: enableTeamCentral
                //   ? getConfig().teamCentralUrl
                //   : undefined,
                cacheSize: 20,
                cacheMaxAge: $d9451ac875294dd9$var$CACHE_MAX_AGE,
                cloudId: cloudId
            });
            setState({
                profileClient: profileClient
            });
            return profileClient;
        }
};
const $d9451ac875294dd9$var$ProfileClientStore = (0, $8s9DV.createStore)({
    initialState: {},
    actions: $d9451ac875294dd9$var$actions
});
const $d9451ac875294dd9$var$useProfileClientState = (0, $kBr4q.createHook)($d9451ac875294dd9$var$ProfileClientStore);
const $d9451ac875294dd9$export$d43dc22a8337ee9f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { enableTeamCentral: t2 } = t1;
    const enableTeamCentral = t2 === undefined ? false : t2;
    const [t3, t4] = $d9451ac875294dd9$var$useProfileClientState();
    const { profileClient: profileClient } = t3;
    const { createClient: createClient } = t4;
    const { stargateRoot: stargateRoot } = (0, $3DKrH.useAppConfig)();
    const cloudId = (0, $f912q.useCloudId)();
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== createClient || $[4] !== enableTeamCentral || $[5] !== stargateRoot) {
        t5 = ()=>{
            createClient(stargateRoot, enableTeamCentral, cloudId);
        };
        t6 = [
            createClient,
            stargateRoot,
            cloudId,
            enableTeamCentral
        ];
        $[2] = cloudId;
        $[3] = createClient;
        $[4] = enableTeamCentral;
        $[5] = stargateRoot;
        $[6] = t5;
        $[7] = t6;
    } else {
        t5 = $[6];
        t6 = $[7];
    }
    (0, $cozmU.useEffect)(t5, t6);
    return profileClient;
} : ({ enableTeamCentral: enableTeamCentral = false } = {})=>{
    const [{ profileClient: profileClient }, { createClient: createClient }] = $d9451ac875294dd9$var$useProfileClientState();
    const { stargateRoot: stargateRoot } = (0, $3DKrH.useAppConfig)();
    const cloudId = (0, $f912q.useCloudId)();
    (0, $cozmU.useEffect)(()=>{
        createClient(stargateRoot, enableTeamCentral, cloudId);
    }, [
        createClient,
        stargateRoot,
        cloudId,
        enableTeamCentral
    ]);
    return profileClient;
};
module.exports["useProfileClient"] = $d9451ac875294dd9$export$d43dc22a8337ee9f;

});

parcelRegister("3DKrH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");








var $cozmU = parcelRequire("cozmU");


var $3m8hU = parcelRequire("3m8hU");


var $ki3sj = parcelRequire("ki3sj");


var $f912q = parcelRequire("f912q");


var $hnAeG = parcelRequire("hnAeG");


var $24Rm0 = parcelRequire("24Rm0");


var $eW61a = parcelRequire("eW61a");


var $kz7tR = parcelRequire("kz7tR");


var $blOKM = parcelRequire("blOKM");

const $109f0aaf646390f4$export$1ac2585b5f6ef8f3 = (href, contextSpaPaths)=>{
    const relativePath = (0, $blOKM.getRelativeUrl)(href);
    const isSPA = $109f0aaf646390f4$export$82ba20246315fbed(relativePath, contextSpaPaths);
    return {
        isSPA: isSPA,
        relativePath: relativePath
    };
};
const $109f0aaf646390f4$export$82ba20246315fbed = (url, contextSpaPaths)=>{
    if (!contextSpaPaths || !contextSpaPaths.length) return false;
    let isStartWithContextSPA;
    if ((0, $blOKM.isAbsoluteLink)(url)) try {
        const { pathname: pathname, search: search, hash: hash, origin: origin } = new URL(url);
        const relativeUrl = `${pathname}${search}${hash}`;
        const isSameDomain = window.location.href.includes(origin);
        isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
            return relativeUrl.startsWith(contextPath);
        });
        return isStartWithContextSPA && isSameDomain;
    } catch (error) {
        (0, $kz7tR.logException)(error, 'Cannot parse URL in isSPALink', {
            url: url
        });
        return false;
    }
    // is relative link
    isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
        return url.startsWith(contextPath);
    });
    return isStartWithContextSPA || !url.startsWith('/');
};
const $109f0aaf646390f4$export$f9ded33a1a6c97c7 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $109f0aaf646390f4$export$ac5aae95c9992c3a = (href, config)=>(0, $blOKM.isAbsoluteLink)(href) ? href : (0, $eW61a.toTeamsAppURL)(href, '', config);


const $ccfdff0c8bb0ecbc$export$7e924b3091a3bd18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = (0, $24Rm0.useNavigationState)();
    const { push: push } = (0, $hnAeG.useNavigationActions)();
    const { openLinksInNewTab: openLinksInNewTab, openPreviewPanel: openPreviewPanel } = (0, $24Rm0.useAppConfigStoreState)();
    const [t0] = (0, $ki3sj.useOrg)();
    const { orgId: orgId } = t0;
    const [t1] = (0, $f912q.useSite)();
    const { cloudId: cloudId } = t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== contextEntryPoint || $[2] !== contextSpaPaths || $[3] !== openLinksInNewTab || $[4] !== openPreviewPanel || $[5] !== orgId || $[6] !== push) {
        t2 = (props)=>{
            const { href: href, onClick: onClick, target: inputTarget, openPreviewPanelProps: openPreviewPanelProps, ...rest } = props;
            const { relativePath: relativePath, isSPA: isSPA } = (0, $109f0aaf646390f4$export$1ac2585b5f6ef8f3)(href, contextSpaPaths ?? []);
            const absoluteLink = (0, $109f0aaf646390f4$export$ac5aae95c9992c3a)(href, {
                orgId: orgId,
                cloudId: cloudId
            });
            let target;
            if (openLinksInNewTab) target = "_blank";
            else {
                if (inputTarget) target = inputTarget;
                else if (isSPA) target = undefined;
            }
            const handleClick = (event)=>{
                if (onClick) onClick(event);
                if (openPreviewPanel && openPreviewPanelProps) try {
                    openPreviewPanel(openPreviewPanelProps);
                    event.preventDefault();
                    return;
                } catch (t3) {
                    const error = t3;
                }
                if (openLinksInNewTab && !(0, $109f0aaf646390f4$export$f9ded33a1a6c97c7)(event)) {
                    event.preventDefault();
                    window.open(absoluteLink, "_blank", "noopener, noreferrer");
                    return;
                }
                if (isSPA && !event.defaultPrevented && event.button === 0 && (!target || target === "_self") && !(0, $109f0aaf646390f4$export$f9ded33a1a6c97c7)(event)) {
                    event.preventDefault();
                    push(relativePath);
                }
            };
            return {
                ...rest,
                href: openLinksInNewTab ? absoluteLink : (0, $3m8hU.prefixWithContextEntryPoint)(href, contextEntryPoint),
                target: target,
                ...!isSPA || target === "_blank" || openLinksInNewTab ? {
                    rel: "noopener noreferrer"
                } : {},
                onClick: handleClick
            };
        };
        $[0] = cloudId;
        $[1] = contextEntryPoint;
        $[2] = contextSpaPaths;
        $[3] = openLinksInNewTab;
        $[4] = openPreviewPanel;
        $[5] = orgId;
        $[6] = push;
        $[7] = t2;
    } else t2 = $[7];
    const getLinkProps = t2;
    return getLinkProps;
} : ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = (0, $24Rm0.useNavigationState)();
    const { push: push } = (0, $hnAeG.useNavigationActions)();
    const { openLinksInNewTab: openLinksInNewTab, openPreviewPanel: openPreviewPanel } = (0, $24Rm0.useAppConfigStoreState)();
    const [{ orgId: orgId }] = (0, $ki3sj.useOrg)();
    const [{ cloudId: cloudId }] = (0, $f912q.useSite)();
    const getLinkProps = (0, $cozmU.useCallback)((props)=>{
        const { href: href, onClick: onClick, target: inputTarget, openPreviewPanelProps: openPreviewPanelProps, ...rest } = props;
        const { relativePath: relativePath, isSPA: isSPA } = (0, $109f0aaf646390f4$export$1ac2585b5f6ef8f3)(href, contextSpaPaths ?? []);
        const absoluteLink = (0, $109f0aaf646390f4$export$ac5aae95c9992c3a)(href, {
            orgId: orgId,
            cloudId: cloudId
        });
        let target;
        if (openLinksInNewTab) target = '_blank';
        else if (inputTarget) target = inputTarget;
        else if (isSPA) target = undefined;
        const handleClick = (event)=>{
            if (onClick) onClick(event);
            if (openPreviewPanel && openPreviewPanelProps) try {
                openPreviewPanel(openPreviewPanelProps);
                event.preventDefault();
                return;
            } catch (error) {}
            // if the event is modified, we want to let the browser handle the link logic
            if (openLinksInNewTab && !(0, $109f0aaf646390f4$export$f9ded33a1a6c97c7)(event)) {
                event.preventDefault();
                window.open(absoluteLink, '_blank', 'noopener, noreferrer');
                return;
            }
            if (isSPA && // only use push for links that work for SPA transitions
            !event.defaultPrevented && // set when onClick called preventDefault
            event.button === 0 && // only use push for left mouse button clicks
            (!target || target === '_self') && // let browser handle "_blank" etc
            !(0, $109f0aaf646390f4$export$f9ded33a1a6c97c7)(event) // let browser handle clicks with modifier
            ) {
                event.preventDefault();
                push(relativePath);
            }
        };
        return {
            ...rest,
            href: openLinksInNewTab ? absoluteLink : (0, $3m8hU.prefixWithContextEntryPoint)(href, contextEntryPoint),
            target: target,
            ...!isSPA || target === '_blank' || openLinksInNewTab ? {
                rel: 'noopener noreferrer'
            } : {},
            onClick: handleClick
        };
    }, [
        contextSpaPaths,
        contextEntryPoint,
        openPreviewPanel,
        openLinksInNewTab,
        orgId,
        cloudId,
        push
    ]);
    return getLinkProps;
};











const $4b3def66ba389536$export$d0fd4b7106de2769 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const state = (0, $24Rm0.useNavigationState)();
    const actions = (0, $hnAeG.useNavigationActions)();
    const getLinkProps = (0, $ccfdff0c8bb0ecbc$export$7e924b3091a3bd18)();
    let t0;
    if ($[0] !== actions || $[1] !== getLinkProps || $[2] !== state) {
        t0 = {
            ...actions,
            ...state,
            getLinkProps: getLinkProps
        };
        $[0] = actions;
        $[1] = getLinkProps;
        $[2] = state;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const state = (0, $24Rm0.useNavigationState)();
    const actions = (0, $hnAeG.useNavigationActions)();
    const getLinkProps = (0, $ccfdff0c8bb0ecbc$export$7e924b3091a3bd18)();
    return {
        ...actions,
        ...state,
        getLinkProps: getLinkProps
    };
};
const $4b3def66ba389536$export$a3e0ece8c3f698d7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const storeState = (0, $24Rm0.useAppConfigStoreState)();
    const navigation = $4b3def66ba389536$export$d0fd4b7106de2769();
    const addFlag = (0, $hnAeG.useAddFlag)();
    const removeFlag = (0, $hnAeG.useRemoveFlag)();
    let t0;
    if ($[0] !== addFlag || $[1] !== navigation || $[2] !== removeFlag || $[3] !== storeState) {
        t0 = {
            ...storeState,
            ...navigation,
            addFlag: addFlag,
            removeFlag: removeFlag
        };
        $[0] = addFlag;
        $[1] = navigation;
        $[2] = removeFlag;
        $[3] = storeState;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const storeState = (0, $24Rm0.useAppConfigStoreState)();
    const navigation = $4b3def66ba389536$export$d0fd4b7106de2769();
    const addFlag = (0, $hnAeG.useAddFlag)();
    const removeFlag = (0, $hnAeG.useRemoveFlag)();
    return {
        ...storeState,
        ...navigation,
        addFlag: addFlag,
        removeFlag: removeFlag
    };
};
module.exports["useNavigation"] = $4b3def66ba389536$export$d0fd4b7106de2769;
module.exports["useAppConfig"] = $4b3def66ba389536$export$a3e0ece8c3f698d7;

});

parcelRegister("3m8hU", function(module, exports) {
const $265eac5ded0b377d$var$isAbsoluteLink = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $265eac5ded0b377d$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
    if ($265eac5ded0b377d$var$isAbsoluteLink(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
module.exports["prefixWithContextEntryPoint"] = $265eac5ded0b377d$export$715c8f9057ac0c01;

});

parcelRegister("ki3sj", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $8s9DV = parcelRequire("8s9DV");

const $c86274db8640dfb3$var$actions = {
    setOrgId: (orgId)=>({ setState: setState })=>{
            setState({
                orgId: orgId
            });
        }
};
const $c86274db8640dfb3$var$initialState = {
    orgId: undefined
};
const $c86274db8640dfb3$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $c86274db8640dfb3$var$initialState,
    actions: $c86274db8640dfb3$var$actions,
    name: 'Org'
});


const $414e0677639e7579$export$7f785727a26e156 = (0, $kBr4q.createHook)((0, $c86274db8640dfb3$export$390f32400eaf98c9));
module.exports["useOrg"] = $414e0677639e7579$export$7f785727a26e156;

});

parcelRegister("f912q", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $kBr4q = parcelRequire("kBr4q");


var $8s9DV = parcelRequire("8s9DV");

const $aa92a9937978b783$var$actions = {
    // This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
    setCloudId: (cloudId)=>({ setState: setState })=>{
            setState({
                cloudId: cloudId
            });
        }
};
const $aa92a9937978b783$var$initialState = {
    cloudId: ''
};
const $aa92a9937978b783$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $aa92a9937978b783$var$initialState,
    actions: $aa92a9937978b783$var$actions,
    name: 'Site'
});


const $61a667529ed2ff6b$export$7870fa8e7cdd59f8 = (0, $kBr4q.createHook)((0, $aa92a9937978b783$export$390f32400eaf98c9));
const $61a667529ed2ff6b$export$9da0f7c65f28ed16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $61a667529ed2ff6b$export$7870fa8e7cdd59f8()[0].cloudId;
} : ()=>$61a667529ed2ff6b$export$7870fa8e7cdd59f8()[0].cloudId;
module.exports["useSite"] = $61a667529ed2ff6b$export$7870fa8e7cdd59f8;
module.exports["useCloudId"] = $61a667529ed2ff6b$export$9da0f7c65f28ed16;

});

parcelRegister("5MJ4T", function(module, exports) {

var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $iDrrr = parcelRequire("iDrrr");


var $dZPDC = parcelRequire("dZPDC");




var $1f4c1eb3d381aad6$var$MemberType = /*#__PURE__*/ function(MemberType) {
    MemberType[MemberType["CURRENT_USER"] = 0] = "CURRENT_USER";
    MemberType[MemberType["MEMBER"] = 1] = "MEMBER";
    MemberType[MemberType["INVITED"] = 2] = "INVITED";
    MemberType[MemberType["INACTIVE"] = 3] = "INACTIVE";
    MemberType[MemberType["DELETED"] = 4] = "DELETED";
    return MemberType;
}($1f4c1eb3d381aad6$var$MemberType || {});
const $1f4c1eb3d381aad6$var$checkType = (member, currentAccountId)=>{
    if (member.membershipId.memberId === currentAccountId) return 0;
    else if (member && member.state === 'INVITED') return 2;
    else if (member.user?.status === 'inactive') return 3;
    else if (member.user?.status === 'closed') return 4;
    else return 1;
};
const $1f4c1eb3d381aad6$export$90b27c15351f4a21 = (members, currentAccountId)=>{
    const newMembers = members.map((member)=>({
            member: member,
            type: $1f4c1eb3d381aad6$var$checkType(member, currentAccountId)
        }));
    newMembers.sort(({ member: memberA, type: typeA }, { member: memberB, type: typeB })=>{
        if (typeA === typeB) return memberA.user?.fullName.localeCompare(memberB.user?.fullName || '') || 0;
        else return typeA - typeB;
    });
    return newMembers.map(({ member: member })=>member);
};




function $243397cfa2dc086e$export$7fb758c207c3ab4b(result) {
    return result.pageInfo !== undefined;
}



var $kz7tR = parcelRequire("kz7tR");

const $a4678a0485af375c$export$eb1265581ad35874 = (teamId)=>async ({ getState: getState, setState: setState })=>{
        const initialState = getState();
        const isOpenTeam = initialState.teamProfile.data.membershipSettings === 'OPEN';
        const membershipErrors = initialState.teamMembers.hasError;
        const hasPermissionToViewRequestingUsers = initialState.teamProfile.data.permission === 'FULL_WRITE';
        const teamChanged = initialState.teamMembers.teamId !== teamId;
        if (teamChanged || !hasPermissionToViewRequestingUsers || membershipErrors || isOpenTeam) return [];
        try {
            const requestingUsersResponse = await (0, $dZPDC.teamsClient).queryTeamMemberships(teamId, [
                'REQUESTING_TO_JOIN'
            ], {
                first: 100,
                after: initialState.teamMembers.requestingToJoinUsersPageInfo.cursor ?? undefined
            });
            const requestingUsers = (0, $243397cfa2dc086e$export$7fb758c207c3ab4b)(requestingUsersResponse) ? requestingUsersResponse.edges : requestingUsersResponse;
            const state = getState();
            if (state.teamMembers.teamId !== teamId) return [];
            const sortedRequesters = (0, $1f4c1eb3d381aad6$export$90b27c15351f4a21)(requestingUsers);
            setState({
                teamMembers: {
                    ...state.teamMembers,
                    requestingToJoinUsers: sortedRequesters
                }
            });
            return sortedRequesters;
        } catch (err) {
            (0, $kz7tR.logException)(err, 'Could not load requesting-to-join users');
            return [];
        }
    };
const $a4678a0485af375c$export$d71ce2a87bc937b0 = (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
        await (0, $dZPDC.teamsClient).declineJoinRequest(teamId, memberId);
        const state = getState();
        if (state.teamMembers.teamId !== teamId) return;
        setState({
            ...state,
            teamMembers: {
                ...state.teamMembers,
                requestingToJoinUsers: state.teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
            }
        });
    };



const $0ee5fb692c82ba21$export$6842649be21ecf13 = (teamState, newMembership)=>{
    const { exitedTeams: exitedTeams, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
    const requestingToJoin = newMembership.state === 'REQUESTING_TO_JOIN';
    const teamId = newMembership.membershipId.teamId;
    if (requestingToJoin) return {
        ...teamState,
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: newMembership
        }
    };
    // If we're joining this team, remove it from the set of exited teams
    exitedTeams.delete(teamId);
    const currentUserId = newMembership.membershipId.memberId;
    const newMembers = teamMembers.members.filter((membership)=>{
        return membership.membershipId.memberId !== currentUserId;
    }).concat(newMembership);
    return {
        ...teamState,
        teamProfile: {
            teamId: teamId,
            hasLoaded: true,
            isLoading: false,
            errorType: null,
            data: {
                ...teamProfile.data,
                permission: 'FULL_WRITE'
            }
        },
        teamMembers: {
            teamId: teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            isLoadingNextPage: false,
            errorType: null,
            members: (0, $1f4c1eb3d381aad6$export$90b27c15351f4a21)(newMembers, currentUserId),
            requestingToJoinUsers: teamMembers.requestingToJoinUsers,
            membersPageInfo: teamMembers.membersPageInfo,
            requestingToJoinUsersPageInfo: {
                hasNextPage: false,
                cursor: null
            }
        },
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: newMembership
        }
    };
};


const $cb287d1003df6fed$export$e4da98dc943d58c8 = (teamId, member)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        if (state.teamProfile.teamId !== teamId) return;
        const nextState = (0, $0ee5fb692c82ba21$export$6842649be21ecf13)(state, member);
        setState(nextState);
    };
const $cb287d1003df6fed$export$47f143084f31963c = (teamId, originQuery, user)=>async ({ dispatch: dispatch })=>{
        const response = await (0, $dZPDC.teamsClient).selfJoinTeam(teamId, originQuery);
        const newMembership = {
            ...response,
            user: user
        };
        dispatch($cb287d1003df6fed$export$e4da98dc943d58c8(teamId, newMembership));
        return response;
    };
const $cb287d1003df6fed$export$a0ce1bbc3e3f2e4d = (teamId, currentUserId)=>async ({ dispatch: dispatch, getState: getState })=>{
        const response = await (0, $dZPDC.teamsClient).acceptTeamInvitation(teamId);
        const existingUser = getState().teamMembers.members.find((member)=>member.membershipId.memberId === currentUserId);
        // This membership MUST exist for the user to be able to call this function,
        // and `user` will be defined as this membership comes from the directory.
        if (!existingUser || !existingUser.user) return;
        const newMembership = {
            ...response,
            user: existingUser.user
        };
        dispatch($cb287d1003df6fed$export$e4da98dc943d58c8(teamId, newMembership));
        // Don't await this, let them load afterwards
        dispatch((0, $a4678a0485af375c$export$eb1265581ad35874)(teamId));
    };




const $7e6165500dd7c0f1$export$a355add01c2f52a3 = (teamId, memberId, user)=>async ({ getState: getState, setState: setState })=>{
        const membership = await (0, $dZPDC.teamsClient).acceptJoinRequest(teamId, memberId);
        const state = getState();
        const { myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: { teamId: currentTeamId } } = state;
        if (currentTeamId !== teamId || membership.state !== 'FULL_MEMBER') return;
        const newMembership = {
            ...membership,
            user: user
        };
        const newMembers = teamMembers.members.filter((membership)=>{
            return membership.membershipId.memberId !== memberId;
        }).concat(newMembership);
        const myMembership = myTeamMembership.membership;
        setState({
            ...state,
            teamMembers: {
                teamId: teamId,
                hasLoaded: true,
                isLoadingNextPage: false,
                hasError: false,
                isLoading: false,
                errorType: null,
                membersPageInfo: teamMembers.membersPageInfo,
                requestingToJoinUsersPageInfo: teamMembers.requestingToJoinUsersPageInfo,
                members: (0, $1f4c1eb3d381aad6$export$90b27c15351f4a21)(newMembers, myMembership?.membershipId.memberId),
                requestingToJoinUsers: teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
            }
        });
    };





var $jmOWE = parcelRequire("jmOWE");

const $c458b041bbcac7a9$export$72e6f466f46f9da0 = (teamId, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: false,
                membership: undefined
            }
        });
        const { myTeamMembership: myTeamMembership } = getState();
        if (myTeamMembership.teamId !== teamId) return;
        const { value: membership } = await (0, $jmOWE.promiseWithDefault)((0, $dZPDC.teamsClient).getMyTeamMembership(teamId), undefined);
        const { teamMembers: teamMembers } = getState();
        const members = teamMembers.members;
        const sortedMembers = members.length > 0 && !!membership ? {
            teamMembers: {
                ...teamMembers,
                members: (0, $1f4c1eb3d381aad6$export$90b27c15351f4a21)(members, membership.membershipId.memberId)
            }
        } : {};
        setState({
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: membership
            },
            ...sortedMembers
        });
    };




const $4e2e234725c13cde$export$f76b45f74ed3aad8 = (teamId, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            teamAgents: {
                teamId: teamId,
                isLoading: true,
                isLoadingNextPage: false,
                hasLoaded: false,
                hasError: false,
                errorType: null,
                members: [],
                agents: []
            }
        });
        if (getState().teamAgents.teamId !== teamId) {
            setState({
                teamAgents: {
                    ...getState().teamAgents,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: false,
                    hasError: false,
                    errorType: null
                }
            });
            return;
        }
        setState({
            teamAgents: {
                ...getState().teamAgents
            }
        });
        try {
            const agentsResponse = await (0, $dZPDC.teamsClient).queryTeamHasAgents(teamId);
            setState({
                teamAgents: {
                    ...getState().teamAgents,
                    isLoading: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    agents: agentsResponse
                }
            });
        } catch (error) {
            if (getState().teamAgents.teamId !== teamId) return;
            setState({
                teamAgents: {
                    ...getState().teamAgents,
                    isLoading: false,
                    hasLoaded: true,
                    hasError: true,
                    members: [],
                    agents: [],
                    errorType: error
                }
            });
        }
    };





const $269dd0fcd47fbd17$var$combineIn = (existing, newData)=>{
    const addedMemberIds = new Set(newData.map((member)=>member.membershipId.memberId));
    return existing.filter((member)=>!addedMemberIds.has(member.membershipId.memberId)).concat(newData);
};
const $269dd0fcd47fbd17$export$e662071d38e352a1 = (teamId, keepExistingData, first = 100)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            teamMembers: {
                teamId: teamId,
                isLoading: true,
                isLoadingNextPage: false,
                hasLoaded: false,
                hasError: false,
                errorType: null,
                members: [],
                requestingToJoinUsers: [],
                membersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                },
                requestingToJoinUsersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                }
            },
            teamAgents: {
                teamId: teamId,
                isLoading: true,
                isLoadingNextPage: false,
                hasLoaded: false,
                hasError: false,
                errorType: null,
                members: [],
                agents: []
            }
        });
        const { teamMembers: teamMembers } = getState();
        if (teamMembers.teamId !== teamId) return;
        setState({
            teamMembers: {
                ...teamMembers,
                isLoadingNextPage: true
            },
            teamAgents: {
                ...getState().teamAgents
            }
        });
        try {
            const membershipsResponse = await (0, $dZPDC.teamsClient).queryTeamMemberships(teamId, [
                'FULL_MEMBER'
            ], {
                first: first,
                after: teamMembers.membersPageInfo.cursor ?? undefined
            });
            const memberships = (0, $243397cfa2dc086e$export$7fb758c207c3ab4b)(membershipsResponse) ? membershipsResponse.edges : membershipsResponse;
            const pageInfo = (0, $243397cfa2dc086e$export$7fb758c207c3ab4b)(membershipsResponse) ? membershipsResponse.pageInfo : {
                hasNextPage: false,
                endCursor: null
            };
            const myMembership = getState().myTeamMembership.membership;
            const myAccountId = myMembership?.membershipId.memberId;
            const membershipsWithExisting = keepExistingData ? $269dd0fcd47fbd17$var$combineIn(teamMembers.members, memberships) : memberships;
            const sortedMembers = (0, $1f4c1eb3d381aad6$export$90b27c15351f4a21)(membershipsWithExisting, myAccountId);
            const membersWithoutAgents = sortedMembers.filter((member)=>!(member.user?.userType === 'agent'));
            const agents = sortedMembers.filter((member)=>member.user?.userType === 'agent');
            setState({
                teamMembers: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    members: membersWithoutAgents,
                    requestingToJoinUsers: [],
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    membersPageInfo: {
                        hasNextPage: pageInfo.hasNextPage,
                        cursor: pageInfo.endCursor
                    }
                },
                teamAgents: {
                    ...getState().teamAgents,
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    members: agents
                }
            });
        } catch (e) {
            if (getState().teamMembers.teamId !== teamId) return;
            setState({
                teamMembers: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e,
                    members: [],
                    requestingToJoinUsers: [],
                    membersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    }
                },
                teamAgents: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e,
                    members: [],
                    agents: []
                }
            });
        }
    };




const $a7296ada2294aa5a$export$7a5bb1168a5e8491 = (teamId)=>async ({ setState: setState })=>{
        setState({
            teamProfile: {
                teamId: teamId,
                isLoading: true,
                hasLoaded: false,
                errorType: null,
                data: {}
            }
        });
        try {
            const team = await (0, $dZPDC.teamsClient).getTeamById(teamId);
            setState({
                teamProfile: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: null,
                    data: team
                }
            });
        } catch (e) {
            setState({
                teamProfile: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: e,
                    data: {}
                }
            });
        }
    };








var $f4SJr = parcelRequire("f4SJr");


const $43224eecdbe41dec$export$d7fb3590d40d5847 = (teamState, newMemberships)=>{
    const { teamAgents: teamAgents } = teamState;
    const memberIds = new Set(newMemberships.map(({ membershipId: membershipId })=>membershipId.memberId));
    const existingMembers = teamAgents.members.filter((member)=>{
        return !memberIds.has(member.membershipId.memberId);
    });
    const finalMembers = (0, $1f4c1eb3d381aad6$export$90b27c15351f4a21)(newMemberships.concat(existingMembers));
    return {
        ...teamState,
        teamAgents: {
            ...teamState.teamAgents,
            teamId: teamState.teamAgents.teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            errorType: null,
            members: finalMembers
        }
    };
};


const $6bae61c04671b788$export$8f3a722ac3583593 = (teamId, members)=>async ({ getState: getState, setState: setState })=>{
        (0, $f4SJr.addNewMembertoTeamSubExp).addMetadata({
            apiVersion: 'v4'
        });
        const addMembershipResponse = await (0, $dZPDC.teamsClient).addUsersToTeam(teamId, members.map((member)=>({
                accountId: member.id
            })));
        const memberships = addMembershipResponse.members.reduce((acc, partial)=>{
            if (!partial.accountId) {
                (0, $kz7tR.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Membership in response was invalid',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            const user = members.find((member)=>member.id === partial.accountId);
            if (!user) {
                (0, $kz7tR.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Could not find user details for this member',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            acc.push({
                membershipId: {
                    teamId: teamId,
                    memberId: partial.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR',
                user: {
                    id: user.id,
                    fullName: user.name,
                    avatarUrl: user.avatarUrl,
                    userType: 'user'
                }
            });
            return acc;
        }, []);
        const state = getState();
        // If focused team has changed whilst invite request was resolving, abort.
        if (teamId !== state.teamMembers.teamId) return;
        // Update the state with the new members.
        const nextState = (0, $43224eecdbe41dec$export$d7fb3590d40d5847)(state, memberships);
        setState(nextState);
        return memberships;
    };










const $b620ef50406f8307$export$d7fb3590d40d5847 = (teamState, newMemberships)=>{
    const { teamMembers: teamMembers } = teamState;
    const memberIds = new Set(newMemberships.map(({ membershipId: membershipId })=>membershipId.memberId));
    const existingMembers = teamMembers.members.filter((member)=>{
        return !memberIds.has(member.membershipId.memberId);
    });
    const currentUserId = teamState.myTeamMembership.membership?.membershipId.memberId;
    const finalMembers = (0, $1f4c1eb3d381aad6$export$90b27c15351f4a21)(newMemberships.concat(existingMembers), currentUserId);
    return {
        ...teamState,
        teamMembers: {
            ...teamState.teamMembers,
            teamId: teamState.teamMembers.teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            errorType: null,
            members: finalMembers
        }
    };
};
const $b620ef50406f8307$var$fetchJobTitlesOfNewMembers = (teamId, unpopulatedMembers, _originQuery)=>async ({ getState: getState, setState: setState })=>{
        Promise.all(unpopulatedMembers.map((membership)=>{
            return (0, $dZPDC.teamsClient).queryAGGUser(membership.membershipId.memberId).then((user)=>{
                return {
                    ...membership,
                    user: {
                        ...membership.user,
                        title: user.extendedProfile?.jobTitle
                    }
                };
            });
        })).then((memberships)=>{
            const state = getState();
            // Cancel if the data we fetched is stale
            if (state.teamMembers.teamId !== teamId) return;
            const titles = {};
            for (const member of memberships)titles[member.membershipId.memberId] = member.user.title || undefined;
            setState({
                ...state,
                teamMembers: {
                    ...state.teamMembers,
                    members: state.teamMembers.members.map(// @ts-ignore
                    (member)=>{
                        return {
                            ...member,
                            user: {
                                ...member.user,
                                title: titles[member.membershipId.memberId] || member.user.title
                            }
                        };
                    })
                }
            });
        }).catch((error)=>{
            (0, $kz7tR.logException)(error, 'Could not populate new team members with titles');
        });
    };
const $b620ef50406f8307$export$ac31c528ad2c8490 = (teamId, members, originQuery)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
        (0, $f4SJr.addNewMembertoTeamSubExp).addMetadata({
            apiVersion: 'v4'
        });
        const addMembershipResponse = await (0, $dZPDC.teamsClient).addUsersToTeam(teamId, members.map((member)=>({
                accountId: member.id
            })));
        const memberships = addMembershipResponse.members.reduce((acc, partial)=>{
            if (!partial.accountId) {
                (0, $kz7tR.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Membership in response was invalid',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            const user = members.find((member)=>member.id === partial.accountId);
            if (!user) {
                (0, $kz7tR.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Could not find user details for this member',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            acc.push({
                membershipId: {
                    teamId: teamId,
                    memberId: partial.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR',
                user: {
                    id: user.id,
                    fullName: user.name,
                    avatarUrl: user.avatarUrl,
                    userType: 'user',
                    title: user.title
                }
            });
            return acc;
        }, []);
        const state = getState();
        // If focused team has changed whilst invite request was resolving, abort.
        if (teamId !== state.teamMembers.teamId) return;
        // Update the state with the new members.
        const nextState = $b620ef50406f8307$export$d7fb3590d40d5847(state, memberships);
        setState(nextState);
        // Send request to populate job titles off the main thread.
        const unpopulatedMembers = addMembershipResponse.members.map((member)=>({
                membershipId: {
                    teamId: teamId,
                    memberId: member.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR'
            }));
        dispatch($b620ef50406f8307$var$fetchJobTitlesOfNewMembers(teamId, unpopulatedMembers, originQuery));
        return memberships;
    };




const $6d114654b6acb31d$var$TIMEOUT_DELAY = 5000;
function $6d114654b6acb31d$var$membershipMaker(teamId) {
    return (user)=>{
        return {
            membershipId: {
                teamId: teamId,
                memberId: user.id
            },
            state: 'FULL_MEMBER',
            role: 'REGULAR',
            user: user
        };
    };
}
const $6d114654b6acb31d$export$bc2925813ab9bc57 = (teamId, teamData, members, currentUser)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const newState = {
            ...getState(),
            teamProfile: {
                teamId: teamId,
                isLoading: false,
                hasLoaded: true,
                errorType: null,
                data: teamData
            },
            teamMembers: {
                teamId: teamId,
                isLoading: false,
                isLoadingNextPage: false,
                hasLoaded: true,
                hasError: false,
                errorType: null,
                members: (0, $1f4c1eb3d381aad6$export$90b27c15351f4a21)(members.map($6d114654b6acb31d$var$membershipMaker(teamId)), currentUser.id),
                requestingToJoinUsers: [],
                membersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                },
                requestingToJoinUsersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                }
            },
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: members.some((x)=>x.id === currentUser.id) ? $6d114654b6acb31d$var$membershipMaker(teamId)(currentUser) : undefined
            }
        };
        setState(newState);
        setTimeout(()=>{
            if (getState().teamProfile.teamId !== teamId) return;
            dispatch((0, $269dd0fcd47fbd17$export$e662071d38e352a1)(teamId, true));
            dispatch((0, $c458b041bbcac7a9$export$72e6f466f46f9da0)(teamId, true));
        }, $6d114654b6acb31d$var$TIMEOUT_DELAY);
    };




const $b6408a3c95bbdc71$export$1c43837b29355a68 = (teamState, memberId, _permissions)=>{
    const { teamProfile: teamProfile, teamAgents: teamAgents } = teamState;
    const teamId = teamProfile.teamId;
    const finalAgents = {
        ...teamAgents,
        teamId: teamId,
        hasLoaded: true,
        hasError: false,
        isLoading: false,
        errorType: null,
        members: teamAgents.members.filter((agent)=>!!agent.user && agent.user.id !== memberId)
    };
    return {
        ...teamState,
        teamAgents: finalAgents
    };
};
const $b6408a3c95bbdc71$export$882fa52d46a08b67 = (teamState, agentId)=>{
    const { teamProfile: teamProfile, teamAgents: teamAgents } = teamState;
    const teamId = teamProfile.teamId;
    const finalAgents = {
        ...teamAgents,
        teamId: teamId,
        hasLoaded: true,
        hasError: false,
        isLoading: false,
        errorType: null,
        agents: teamAgents.agents.filter(({ associationId: associationId })=>associationId.accountId !== agentId)
    };
    return {
        ...teamState,
        teamAgents: finalAgents
    };
};
const $b6408a3c95bbdc71$export$cc0fe1b8e0afca8c = (teamId, agentAtlassianAccountId, permissions)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const removeMembershipResponse = await (0, $dZPDC.teamsClient).removeTeamMemberships(teamId, [
            {
                accountId: agentAtlassianAccountId
            }
        ]);
        // as we only removing 1 member at a time, it is safe to say task failed with even 1 error
        if (removeMembershipResponse.errors && removeMembershipResponse.errors.length) throw Error('Membership claims to be removed but was not');
        if (state.teamMembers.teamId !== teamId) return;
        const nextState = $b6408a3c95bbdc71$export$1c43837b29355a68(state, agentAtlassianAccountId, permissions);
        setState(nextState);
    };
const $b6408a3c95bbdc71$export$ef4d649346805a8c = (teamId, agentId, onRemoveAgentSuccess)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await (0, $dZPDC.teamsClient).removeAgentTeamAssociation(teamId, agentId);
        onRemoveAgentSuccess?.(agentId, teamId);
        if (state.teamMembers.teamId !== teamId) return;
        const nextState = $b6408a3c95bbdc71$export$882fa52d46a08b67(state, agentId);
        setState(nextState);
    };




const $1c6439d2fe849d7e$export$87a89dfcfcd29512 = (teamState, memberId, permissions)=>{
    const { exitedTeams: exitedTeams, myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
    const teamId = myTeamMembership.teamId;
    const myMembership = myTeamMembership.membership;
    const isCurrentUser = myMembership && myMembership.membershipId.memberId === memberId;
    const finalMembers = {
        ...teamMembers,
        teamId: teamId,
        hasLoaded: true,
        hasError: false,
        isLoading: false,
        errorType: null,
        members: teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
    };
    if (!isCurrentUser) return {
        ...teamState,
        teamMembers: finalMembers
    };
    // No longer a part of this team, hide it from search results
    exitedTeams.add(teamId);
    const currentTeam = teamProfile.data;
    /**
   * Allow admins to manage teams after they are removed from the team
   * If currentTeam.permission is not undefined and user is not admin, they can only view the team after removal, set permission to FULL_READ
   * If currentTeam.permission is not undefined and user is admin, they can still manage the team after removal, set permission to FULL_WRITE
   * If currentTeam.permission is undefined, don't override the permission
   */ const permissionAfterRemoval = currentTeam.permission ? permissions?.canAdminTeams ? 'FULL_WRITE' : 'FULL_READ' : currentTeam.permission;
    // Nullify myMembership and change permission
    return {
        ...teamState,
        teamMembers: finalMembers,
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: undefined
        },
        teamProfile: {
            teamId: teamId,
            isLoading: false,
            hasLoaded: true,
            errorType: null,
            data: {
                ...currentTeam,
                permission: permissionAfterRemoval
            }
        }
    };
};
const $1c6439d2fe849d7e$export$f7c0e1c7a2575f28 = (teamId, memberId, permissions)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const removeMembershipResponse = await (0, $dZPDC.teamsClient).removeTeamMemberships(teamId, [
            {
                accountId: memberId
            }
        ]);
        // as we only removing 1 member at a time, it is safe to say task failed with even 1 error
        if (removeMembershipResponse.errors && removeMembershipResponse.errors.length) throw Error('Membership claims to be removed but was not');
        if (state.teamMembers.teamId !== teamId) return;
        const nextState = $1c6439d2fe849d7e$export$87a89dfcfcd29512(state, memberId, permissions);
        setState(nextState);
    };








const $be85d36140070bf3$export$7fc97a23b65619cb = (teamState, newAgents)=>{
    const { teamAgents: teamAgents } = teamState;
    const accountIds = new Set(newAgents.map(({ associationId: associationId })=>associationId.accountId));
    const existingAgents = teamAgents.agents.filter((agent)=>{
        return !accountIds.has(agent.associationId.accountId);
    });
    const finalAgents = existingAgents.concat(newAgents);
    return {
        ...teamState,
        teamAgents: {
            ...teamState.teamAgents,
            teamId: teamState.teamAgents.teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            errorType: null,
            agents: finalAgents
        }
    };
};


const $e43aba72ab49104d$export$47e0e7d94501fb19 = (teamId, agents)=>async ({ getState: getState, setState: setState })=>{
        const agentIds = agents.map((agent)=>agent.id);
        const addAgentsResponse = await (0, $dZPDC.teamsClient).addAgentsToTeam(teamId, agentIds);
        const associations = addAgentsResponse.agents.reduce((acc, agentId)=>{
            if (!agentId) {
                (0, $kz7tR.logErrorMessage)('teamAgentAssociationInvalidResponse', {
                    message: 'Agent association in response was invalid',
                    agent: agentId,
                    response: addAgentsResponse
                });
                return acc;
            }
            const agent = agents.find((agent)=>agent.id === agentId);
            if (!agent) {
                (0, $kz7tR.logErrorMessage)('teamAgentAssociationInvalidResponse', {
                    message: 'Could not find agent details for this association',
                    agent: agentId,
                    response: addAgentsResponse
                });
                return acc;
            }
            acc.push({
                associationId: {
                    accountId: agentId,
                    teamId: teamId
                },
                agent: {
                    id: agent.id,
                    avatarUrl: agent.avatarUrl,
                    fullName: agent.name
                }
            });
            return acc;
        }, []);
        const state = getState();
        const nextState = (0, $be85d36140070bf3$export$7fc97a23b65619cb)(state, associations);
        setState(nextState);
        return associations;
    };





const $79326276ab453360$export$ab8050468a2292b9 = (currentTeamAppState, teamData)=>{
    const { teamProfile: teamProfile } = currentTeamAppState;
    const currentTeam = teamProfile.data;
    return {
        ...currentTeamAppState,
        teamProfile: {
            ...teamProfile,
            data: {
                ...currentTeam,
                state: teamData?.state,
                isVerified: teamData?.isVerified,
                smallAvatarImageUrl: teamData?.smallAvatarImageUrl,
                membershipSettings: teamData?.membershipSettings
            }
        }
    };
};
const $79326276ab453360$export$30ae3e8685ff2f4b = (teamId)=>async ({ getState: getState, setState: setState })=>{
        try {
            const state = getState();
            const response = await (0, $dZPDC.teamsClient).archiveTeam(teamId);
            if (state.teamProfile.teamId !== teamId) return;
            const nextState = $79326276ab453360$export$ab8050468a2292b9(state, response);
            setState(nextState);
            return response;
        } catch (error) {
            throw Error('Unable to Archive the team');
        }
    };
const $79326276ab453360$export$5335cf6ad5dd59f = (teamId)=>async ({ getState: getState, setState: setState })=>{
        try {
            const state = getState();
            const response = await (0, $dZPDC.teamsClient).unarchiveTeam(teamId);
            if (state.teamProfile.teamId !== teamId) return;
            const nextState = $79326276ab453360$export$ab8050468a2292b9(state, response);
            setState(nextState);
            return response;
        } catch (error) {
            throw Error('Unable to Unarchive the team');
        }
    };





const $49c80b82bc1f2ade$var$getAllTeams = (allTeamsQuery, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            allTeamsData: {
                teams: [],
                isLoading: true,
                hasError: false,
                cursor: ''
            }
        });
        try {
            const { teams: newTeams, cursor: cursor } = await (0, $dZPDC.teamsClient).getAllTeams(allTeamsQuery);
            setState({
                allTeamsData: {
                    teams: [
                        ...getState().allTeamsData.teams,
                        ...newTeams
                    ],
                    isLoading: false,
                    hasError: false,
                    cursor: cursor
                }
            });
        } catch (e) {
            setState({
                allTeamsData: {
                    isLoading: false,
                    hasError: true,
                    teams: [],
                    cursor: '',
                    errorStatusCode: e.status
                }
            });
        }
    };
var $49c80b82bc1f2ade$export$2e2bcd8739ae039 = $49c80b82bc1f2ade$var$getAllTeams;





const $3566a23653bb1aa7$export$5f5de69526e753e0 = (teamId)=>async ({ getState: getState, setState: setState })=>{
        try {
            await (0, $dZPDC.teamsClient).unlinkTeamFromGroup(teamId);
            const state = getState();
            if (state.teamProfile.teamId !== teamId) return;
            const { teamProfile: teamProfile } = state;
            const currentTeam = teamProfile.data;
            setState({
                ...state,
                teamProfile: {
                    ...teamProfile,
                    data: {
                        ...currentTeam,
                        isVerified: false,
                        membershipSettings: 'MEMBER_INVITE'
                    }
                }
            });
        } catch (error) {
            throw Error('Unable to Unlink the team');
        }
    };


const $cb73efc6bbe714fc$var$initialState = {
    teamProfile: {
        teamId: '',
        isLoading: true,
        hasLoaded: false,
        errorType: null,
        data: {}
    },
    teamMembers: {
        teamId: '',
        isLoading: true,
        isLoadingNextPage: false,
        hasLoaded: false,
        hasError: false,
        errorType: null,
        members: [],
        requestingToJoinUsers: [],
        membersPageInfo: {
            hasNextPage: false,
            cursor: null
        },
        requestingToJoinUsersPageInfo: {
            hasNextPage: false,
            cursor: null
        }
    },
    teamAgents: {
        teamId: '',
        isLoading: true,
        isLoadingNextPage: false,
        hasLoaded: false,
        hasError: false,
        errorType: null,
        members: [],
        agents: []
    },
    myTeamMembership: {
        teamId: '',
        hasLoaded: false,
        membership: undefined
    },
    exitedTeams: new Set(),
    allTeamsData: {
        teams: [],
        isLoading: true,
        hasError: false,
        cursor: ''
    }
};
const $cb73efc6bbe714fc$var$actions = {
    /**
   * @deprecated set the config on the teamsClient using useTeamsClientSetup
   */ setTeamClientRootUrl: (rootUrl)=>()=>{
            (0, $dZPDC.teamsClient).setLegionRootUrl(rootUrl);
        },
    collectTeamData: (teamId, forceRefresh)=>async ({ dispatch: dispatch, getState: getState })=>{
            // If we already have the team's data, do not collect it again
            if (!forceRefresh && getState().teamProfile.teamId === teamId) return;
            await Promise.all([
                dispatch((0, $a7296ada2294aa5a$export$7a5bb1168a5e8491)(teamId)),
                dispatch((0, $c458b041bbcac7a9$export$72e6f466f46f9da0)(teamId)),
                dispatch((0, $269dd0fcd47fbd17$export$e662071d38e352a1)(teamId)),
                (0, $iDrrr.fg)('add_agents_in_new_connection_pattern') && dispatch((0, $4e2e234725c13cde$export$f76b45f74ed3aad8)(teamId))
            ]);
            dispatch((0, $a4678a0485af375c$export$eb1265581ad35874)(teamId));
        },
    restoreTeam: (teamId, options)=>async ({ dispatch: dispatch })=>{
            await (0, $dZPDC.teamsClient).restoreTeam(teamId);
            if (options?.fetchTeamData) await Promise.all([
                dispatch((0, $a7296ada2294aa5a$export$7a5bb1168a5e8491)(teamId)),
                dispatch((0, $c458b041bbcac7a9$export$72e6f466f46f9da0)(teamId)),
                dispatch((0, $269dd0fcd47fbd17$export$e662071d38e352a1)(teamId)),
                (0, $iDrrr.fg)('add_agents_in_new_connection_pattern') && dispatch((0, $4e2e234725c13cde$export$f76b45f74ed3aad8)(teamId))
            ]);
        },
    fetchTeamMembersNextPage: (teamId, count = 100)=>async ({ dispatch: dispatch, getState: getState })=>{
            if (!getState().teamMembers.membersPageInfo.hasNextPage) return;
            await dispatch((0, $269dd0fcd47fbd17$export$e662071d38e352a1)(teamId, true, count));
        },
    refreshRequestingToJoinUsers: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            // Check that we're refreshing data for the current team
            if (getState().teamProfile.teamId !== teamId) return [];
            return await dispatch((0, $a4678a0485af375c$export$eb1265581ad35874)(teamId));
        },
    prefillTeamData: $6d114654b6acb31d$export$bc2925813ab9bc57,
    updateTeamProfile: (teamId, data)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const isTransitioningToOpen = data.membershipSettings === 'OPEN' && getState().teamProfile.data.membershipSettings === 'MEMBER_INVITE';
            const response = await (0, $dZPDC.teamsClient).updateTeamById(teamId, data);
            setState({
                teamProfile: {
                    ...getState().teamProfile,
                    data: response
                }
            });
            if (isTransitioningToOpen) dispatch((0, $269dd0fcd47fbd17$export$e662071d38e352a1)(teamId));
            return response;
        },
    acceptAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            const requests = getState().teamMembers.requestingToJoinUsers;
            await Promise.all(requests.map((request)=>{
                return dispatch((0, $7e6165500dd7c0f1$export$a355add01c2f52a3)(teamId, request.membershipId.memberId, request.user));
            }));
        },
    declineAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            const requests = getState().teamMembers.requestingToJoinUsers;
            await Promise.all(requests.map((request)=>{
                return dispatch((0, $a4678a0485af375c$export$d71ce2a87bc937b0)(teamId, request.membershipId.memberId));
            }));
        },
    removeTeamMember: // Throws if we cannot remove the member
    $1c6439d2fe849d7e$export$f7c0e1c7a2575f28,
    removeTeamAgent: $b6408a3c95bbdc71$export$cc0fe1b8e0afca8c,
    removeTeamAgentAssociation: $b6408a3c95bbdc71$export$ef4d649346805a8c,
    revokeTeamInvite: (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
            const { teamMembers: { teamId: currentTeamId } } = getState();
            const removedInvite = await (0, $dZPDC.teamsClient).revokeTeamInvite(teamId, memberId);
            if (removedInvite && removedInvite.state !== 'ALUMNI') throw Error('Invite claims to be cancelled but was not');
            if (currentTeamId !== teamId) return;
            setState({
                teamMembers: {
                    ...getState().teamMembers,
                    members: getState().teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
                }
            });
        },
    joinTeam: // Throws if teamsClient.selfJoinTeam throws
    $cb287d1003df6fed$export$47f143084f31963c,
    // Throws if teamsClient.cancelJoinRequest throws
    cancelJoinRequest: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { teamProfile: { teamId: currentTeamId } } = getState();
            await (0, $dZPDC.teamsClient).cancelJoinRequest(teamId);
            const state = getState();
            if (currentTeamId !== teamId) return;
            setState({
                ...state,
                myTeamMembership: {
                    teamId: teamId,
                    hasLoaded: true,
                    membership: undefined
                }
            });
        },
    acceptTeamInvitation: // Throws if teamsClient.acceptTeamInvitation throws
    $cb287d1003df6fed$export$a0ce1bbc3e3f2e4d,
    // Throws if teamsClient.declineTeamInvitation throws
    declineTeamInvitation: (teamId)=>async ({ getState: getState })=>{
            const { exitedTeams: exitedTeams } = getState();
            await (0, $dZPDC.teamsClient).declineTeamInvitation(teamId);
            exitedTeams.add(teamId);
        // No need to re-fetch, when an invite is declined we navigate away
        },
    inviteUsersToTeam: // Throws if teamsClient.inviteUsersToTeam or publicApiClient.addUsersToTeam throws
    $b620ef50406f8307$export$ac31c528ad2c8490,
    inviteAgentsToTeam: $6bae61c04671b788$export$8f3a722ac3583593,
    addAgentsToTeam: $e43aba72ab49104d$export$47e0e7d94501fb19,
    approveJoinRequest: // Throws if teamsClient.approveJoinRequest throws
    $7e6165500dd7c0f1$export$a355add01c2f52a3,
    declineJoinRequest: // Throws if teamsClient.declineJoinRequest throws
    $a4678a0485af375c$export$d71ce2a87bc937b0,
    // Throws if teamsClient.deleteTeam throws
    deleteTeam: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { exitedTeams: exitedTeams } = getState();
            await (0, $dZPDC.teamsClient).deleteTeam(teamId);
            setState({
                teamProfile: $cb73efc6bbe714fc$var$initialState.teamProfile,
                teamMembers: $cb73efc6bbe714fc$var$initialState.teamMembers,
                myTeamMembership: $cb73efc6bbe714fc$var$initialState.myTeamMembership
            });
            exitedTeams.add(teamId);
        },
    archiveTeam: $79326276ab453360$export$30ae3e8685ff2f4b,
    unarchiveTeam: $79326276ab453360$export$5335cf6ad5dd59f,
    unlinkExternalTeam: // disconnecting the team from the group before archiving the team
    $3566a23653bb1aa7$export$5f5de69526e753e0,
    getAllTeams: (allTeamsQuery, keepExistingData)=>async ({ dispatch: dispatch })=>{
            await dispatch((0, $49c80b82bc1f2ade$export$2e2bcd8739ae039)(allTeamsQuery, keepExistingData));
        },
    updateTeamMembershipSettings: (teamId, membershipSettings)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.teamProfile.teamId !== teamId) return;
            setState({
                ...state,
                teamProfile: {
                    ...state.teamProfile,
                    data: {
                        ...state.teamProfile.data,
                        membershipSettings: membershipSettings
                    }
                }
            });
        }
};
const $cb73efc6bbe714fc$var$TeamStore = (0, $8s9DV.createStore)({
    initialState: $cb73efc6bbe714fc$var$initialState,
    actions: $cb73efc6bbe714fc$var$actions
});
const $cb73efc6bbe714fc$export$5e2cc6eafd028107 = (0, $j8on0.createContainer)($cb73efc6bbe714fc$var$TeamStore);
const $cb73efc6bbe714fc$export$1983fe04e6d15665 = (0, $kBr4q.createHook)($cb73efc6bbe714fc$var$TeamStore, {
    selector: (state)=>state.teamProfile
});
const $cb73efc6bbe714fc$export$c90591c2030bee = (0, $kBr4q.createHook)($cb73efc6bbe714fc$var$TeamStore, {
    selector: (state)=>state.teamMembers
});
const $cb73efc6bbe714fc$export$7d96b11823e54583 = (0, $kBr4q.createHook)($cb73efc6bbe714fc$var$TeamStore, {
    selector: (state)=>state.myTeamMembership
});
const $cb73efc6bbe714fc$export$d85ae427dffd7a31 = (0, $kBr4q.createHook)($cb73efc6bbe714fc$var$TeamStore, {
    selector: (state)=>state.exitedTeams
});
const $cb73efc6bbe714fc$export$80fb38915e92c27f = (0, $kBr4q.createHook)($cb73efc6bbe714fc$var$TeamStore, {
    selector: (state)=>state.teamAgents
});
module.exports["TeamStoreContainer"] = $cb73efc6bbe714fc$export$5e2cc6eafd028107;
module.exports["useTeamProfileDataState"] = $cb73efc6bbe714fc$export$1983fe04e6d15665;
module.exports["useTeamMembersState"] = $cb73efc6bbe714fc$export$c90591c2030bee;
module.exports["useMyMembership"] = $cb73efc6bbe714fc$export$7d96b11823e54583;
module.exports["useExitedTeams"] = $cb73efc6bbe714fc$export$d85ae427dffd7a31;
module.exports["useTeamAgentsState"] = $cb73efc6bbe714fc$export$80fb38915e92c27f;

});

parcelRegister("f4SJr", function(module, exports) {

var $9CzW0 = parcelRequire("9CzW0");


var $4MiWC = parcelRequire("4MiWC");

var $jmjuG = parcelRequire("jmjuG");


var $j7Sza = parcelRequire("j7Sza");

const $79eaacb0873fdb95$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $79eaacb0873fdb95$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $79eaacb0873fdb95$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($79eaacb0873fdb95$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($79eaacb0873fdb95$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $j7Sza.UFOExperienceState).ABORTED || data.state === (0, $j7Sza.UFOExperienceState).FAILED;
                if (priorityStateFound && doneIndexes.length > 0) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $jmjuG.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $j7Sza.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };


const $be99b357f48a2f91$export$d04a4af02b71bd20 = new (0, $9CzW0.TeamsUFOExperience)('render-team-member-remove-dialog', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$export$6c01b81d5485ad09 = new (0, $9CzW0.TeamsUFOExperience)('render-team-agent-remove-dialog', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$export$8e622ac1f6a9e9f4 = new (0, $9CzW0.TeamsUFOExperience)('remove-member-from-team-action', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$export$76ab6cbd7b588583 = new (0, $9CzW0.TeamsUFOExperience)('remove-agent-from-team-action', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$var$removeMemberFromTeamSubExperiences = [
    $be99b357f48a2f91$export$d04a4af02b71bd20,
    $be99b357f48a2f91$export$8e622ac1f6a9e9f4
];
const $be99b357f48a2f91$export$ded699d92af3fb9e = new (0, $9CzW0.TeamsUFOExperience)('remove-a-member-from-team', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'people'
    },
    until: (0, $79eaacb0873fdb95$export$44695628831598be)($be99b357f48a2f91$var$removeMemberFromTeamSubExperiences.map((experience)=>({
            experience: experience
        })))
});
const $be99b357f48a2f91$export$fa45933fe41dcece = new (0, $9CzW0.TeamsUFOExperience)('remove-a-agent-from-team', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'people'
    },
    until: (0, $79eaacb0873fdb95$export$44695628831598be)($be99b357f48a2f91$var$removeMemberFromTeamSubExperiences.map((experience)=>({
            experience: experience
        })))
});
const $be99b357f48a2f91$export$efd0793305afa76a = new (0, $9CzW0.TeamsUFOExperience)('membership-control-change', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$export$a7f093db8a7d96e1 = new (0, $9CzW0.TeamsUFOExperience)('membership-control-change-handle-requests', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$export$fba164816385656f = new (0, $9CzW0.TeamsUFOExperience)('membership-control-change-change-team-type', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$export$568d3db878ad8d23 = new (0, $9CzW0.TeamsUFOExperience)('render-team-member-invite-dialog', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$export$d691a209050136d6 = new (0, $9CzW0.TeamsUFOExperience)('add-new-member-to-team-action', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$export$a90631bf35cb7c03 = new (0, $9CzW0.TeamsUFOExperience)('link-agent-to-team-action', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $be99b357f48a2f91$export$2bd703f1fbcc240b = new (0, $9CzW0.TeamsUFOExperience)('invite-members-to-team', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'people'
    }
});
module.exports["renderTeamMemberRemoveDialogSubExp"] = $be99b357f48a2f91$export$d04a4af02b71bd20;
module.exports["renderTeamAgentRemoveDialogSubExp"] = $be99b357f48a2f91$export$6c01b81d5485ad09;
module.exports["removeMemberFromTeamSubExp"] = $be99b357f48a2f91$export$8e622ac1f6a9e9f4;
module.exports["removeAgentFromTeamSubExp"] = $be99b357f48a2f91$export$76ab6cbd7b588583;
module.exports["removeMemberFromTeamExp"] = $be99b357f48a2f91$export$ded699d92af3fb9e;
module.exports["removeAgentFromTeamExp"] = $be99b357f48a2f91$export$fa45933fe41dcece;
module.exports["teamSettingsOverallExp"] = $be99b357f48a2f91$export$efd0793305afa76a;
module.exports["teamSettingsChangeTeamTypeExp"] = $be99b357f48a2f91$export$fba164816385656f;
module.exports["renderTeamMemberInviteDialogSubExp"] = $be99b357f48a2f91$export$568d3db878ad8d23;
module.exports["addNewMembertoTeamSubExp"] = $be99b357f48a2f91$export$d691a209050136d6;
module.exports["associateNewAgentToTeamSubExp"] = $be99b357f48a2f91$export$a90631bf35cb7c03;
module.exports["inviteMembersToTeamExperience"] = $be99b357f48a2f91$export$2bd703f1fbcc240b;

});

parcelRegister("gG7Zt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $5MJ4T = parcelRequire("5MJ4T");


var $aAalh = parcelRequire("aAalh");

const $3fe2d3a11c65808e$export$176ea48aece57a5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const teamProfileDataStateSlice = (0, $5MJ4T.useTeamProfileDataState)();
    return (0, $aAalh.useOrCollectData)(teamProfileDataStateSlice);
} : ()=>{
    const teamProfileDataStateSlice = (0, $5MJ4T.useTeamProfileDataState)();
    return (0, $aAalh.useOrCollectData)(teamProfileDataStateSlice);
};
module.exports["useTeamProfileData"] = $3fe2d3a11c65808e$export$176ea48aece57a5e;

});

parcelRegister("aAalh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $9SOcN = parcelRequire("9SOcN");


var $hA8om = parcelRequire("hA8om");

const $1b4ef9146e27d501$export$1eaefd378d4c4c91 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (stateSlice)=>{
    const teamId = (0, $hA8om.useTeamId)();
    const previousTeamId = (0, $9SOcN.default)(teamId);
    if (teamId === null) return stateSlice;
    if (!stateSlice[0].hasLoaded && !stateSlice[0].isLoading || teamId !== previousTeamId) stateSlice[1].collectTeamData(teamId);
    return stateSlice;
} : (stateSlice)=>{
    const teamId = (0, $hA8om.useTeamId)();
    const previousTeamId = (0, $9SOcN.default)(teamId);
    if (teamId === null) return stateSlice;
    if (!stateSlice[0].hasLoaded && !stateSlice[0].isLoading || teamId !== previousTeamId) stateSlice[1].collectTeamData(teamId);
    return stateSlice;
};
module.exports["useOrCollectData"] = $1b4ef9146e27d501$export$1eaefd378d4c4c91;

});

parcelRegister("9SOcN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4aff858cc043e631$var$usePrevious = (value)=>{
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = (0, $cozmU.useRef)();
    // Store current value in ref
    (0, $cozmU.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
};
var $4aff858cc043e631$export$2e2bcd8739ae039 = $4aff858cc043e631$var$usePrevious;
module.exports["default"] = $4aff858cc043e631$export$2e2bcd8739ae039;

});

parcelRegister("hA8om", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $771f47a93503a785$var$TeamContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    teamId: null
});
const $771f47a93503a785$export$1e5e47e568014cdb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamProvider(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children, teamId: teamId } = t0;
    let t1;
    if ($[0] !== teamId) {
        t1 = {
            teamId: teamId
        };
        $[0] = teamId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($771f47a93503a785$var$TeamContext.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function TeamProvider({ children: children, teamId: teamId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($771f47a93503a785$var$TeamContext.Provider, {
        value: {
            teamId: teamId
        }
    }, children);
};
const $771f47a93503a785$export$398c0d27f0571d18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($771f47a93503a785$var$TeamContext).teamId;
} : ()=>(0, $cozmU.useContext)($771f47a93503a785$var$TeamContext).teamId;
module.exports["TeamProvider"] = $771f47a93503a785$export$1e5e47e568014cdb;
module.exports["useTeamId"] = $771f47a93503a785$export$398c0d27f0571d18;

});

parcelRegister("i5Veu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lUcpS = parcelRequire("lUcpS");


var $aTE5s = parcelRequire("aTE5s");


var $kz7tR = parcelRequire("kz7tR");


var $4j5se = parcelRequire("4j5se");


var $4MoGw = parcelRequire("4MoGw");


var $f912q = parcelRequire("f912q");

const $6147e7d3dc7c217a$var$useTeamPermissionsAnalytics = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { data: data, error: error, permissions: permissions } = t0;
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== error || $[1] !== fireEvent) {
        t1 = ()=>{
            if (error) {
                (0, $kz7tR.logException)(error, "Error loading team permissions in useTeamsPermissionsService");
                const { status: status, path: path } = error instanceof Error ? {
                    status: "unknown",
                    path: "unknown"
                } : error;
                fireEvent("operational.teamsPermissionsRequest.failed", {
                    message: error.message,
                    status: status,
                    path: path
                });
            }
        };
        t2 = [
            error,
            fireEvent
        ];
        $[0] = error;
        $[1] = fireEvent;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[4] !== data || $[5] !== fireEvent || $[6] !== permissions) {
        t3 = ()=>{
            if (data && permissions) fireEvent("operational.teamsPermissionsRequest.succeeded", {
                canCreateTeams: permissions.canCreateTeams,
                canViewTeams: permissions.canViewTeams,
                canAdminTeams: !!permissions.canAdminTeams
            });
        };
        t4 = [
            data,
            fireEvent,
            permissions
        ];
        $[4] = data;
        $[5] = fireEvent;
        $[6] = permissions;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
} : ({ data: data, error: error, permissions: permissions })=>{
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            (0, $kz7tR.logException)(error, 'Error loading team permissions in useTeamsPermissionsService');
            const { status: status, path: path } = error instanceof Error ? {
                status: 'unknown',
                path: 'unknown'
            } : error;
            fireEvent('operational.teamsPermissionsRequest.failed', {
                message: error.message,
                status: status,
                path: path
            });
        }
    }, [
        error,
        fireEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data && permissions) fireEvent('operational.teamsPermissionsRequest.succeeded', {
            canCreateTeams: permissions.canCreateTeams,
            canViewTeams: permissions.canViewTeams,
            canAdminTeams: !!permissions.canAdminTeams
        });
    }, [
        data,
        fireEvent,
        permissions
    ]);
};
const $6147e7d3dc7c217a$export$acf57ff2f92f51c1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { orgId: orgId } = (0, $4j5se.useV3OrgIdStatus)();
    const [t0] = (0, $f912q.useSite)();
    const { cloudId: cloudId } = t0;
    const [t1] = (0, $4MoGw.usePrincipalUser)();
    const { principalUserId: principalUserId } = t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== orgId) {
        t2 = {
            orgId: orgId,
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = orgId;
        $[2] = t2;
    } else t2 = $[2];
    const t3 = !!cloudId;
    let t4;
    if ($[3] !== principalUserId) {
        t4 = {
            userId: principalUserId
        };
        $[3] = principalUserId;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = {
            enabled: t3,
            attributes: t4
        };
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const result = (0, $aTE5s.useTeamsPermissionsService)(t2, t5);
    $6147e7d3dc7c217a$var$useTeamPermissionsAnalytics(result);
    const t6 = !cloudId || result.isLoading;
    let t7;
    if ($[8] !== result.permissions || $[9] !== t6) {
        t7 = {
            isLoading: t6,
            permissions: result.permissions
        };
        $[8] = result.permissions;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    return t7;
} : ()=>{
    const { orgId: orgId } = (0, $4j5se.useV3OrgIdStatus)();
    const [{ cloudId: cloudId }] = (0, $f912q.useSite)();
    const [{ principalUserId: principalUserId }] = (0, $4MoGw.usePrincipalUser)();
    const result = (0, $aTE5s.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        // Wait for cloudId to be available before making the request
        enabled: !!cloudId,
        attributes: {
            userId: principalUserId
        }
    });
    $6147e7d3dc7c217a$var$useTeamPermissionsAnalytics(result);
    return {
        isLoading: !cloudId || result.isLoading,
        permissions: result.permissions
    };
};
module.exports["useTeamVisibility"] = $6147e7d3dc7c217a$export$acf57ff2f92f51c1;

});

parcelRegister("4j5se", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $ki3sj = parcelRequire("ki3sj");

const $a0c3b75cad5cfc43$export$52558c271a487a01 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useV3OrgIdStatus() {
    const $ = (0, $bDgLe.c)(3);
    const [t0] = (0, $ki3sj.useOrg)();
    const { orgId: orgId } = t0;
    const t1 = !orgId;
    let t2;
    if ($[0] !== orgId || $[1] !== t1) {
        t2 = {
            orgId: orgId,
            isOrgLoading: t1
        };
        $[0] = orgId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function useV3OrgIdStatus() {
    const [{ orgId: orgId }] = (0, $ki3sj.useOrg)();
    return {
        orgId: orgId,
        isOrgLoading: !orgId
    };
};
module.exports["useV3OrgIdStatus"] = $a0c3b75cad5cfc43$export$52558c271a487a01;

});

parcelRegister("h39Gg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eOw0I = parcelRequire("eOw0I");

var $bG29P = parcelRequire("bG29P");

const $5f0900c178f5e88d$export$710d990c66bc31bc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cloudId)=>{
    const $ = (0, $bDgLe.c)(6);
    const t0 = `/gateway/api/xflow/${cloudId}/license-information`;
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $eOw0I.requestWithAbort)(t0, {
            method: "GET"
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const [request, controller] = t1;
    const [getLicenseCheck, result] = (0, $bG29P.useLazyService)(request, controller);
    let t2;
    let t3;
    if ($[2] !== cloudId || $[3] !== getLicenseCheck) {
        t2 = ()=>{
            if (cloudId) getLicenseCheck();
        };
        t3 = [
            cloudId,
            getLicenseCheck
        ];
        $[2] = cloudId;
        $[3] = getLicenseCheck;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return result;
} : (cloudId)=>{
    const [request, controller] = (0, $cozmU.useMemo)(()=>(0, $eOw0I.requestWithAbort)(`/gateway/api/xflow/${cloudId}/license-information`, {
            method: 'GET'
        }), [
        cloudId
    ]);
    const [getLicenseCheck, result] = (0, $bG29P.useLazyService)(request, controller);
    (0, $cozmU.useEffect)(()=>{
        if (cloudId) getLicenseCheck();
    }, [
        cloudId,
        getLicenseCheck
    ]);
    return result;
};
module.exports["useLicenseCheck"] = $5f0900c178f5e88d$export$710d990c66bc31bc;

});

parcelRegister("1QiV7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $I7hWB = parcelRequire("I7hWB");


var $c9hBE = parcelRequire("c9hBE");

var $9013f3a7d8ef37c6$exports = {};
$9013f3a7d8ef37c6$exports = new URL("svg-error-window_ptc.61deaad9.svg", import.meta.url).toString();












var $hekY6 = parcelRequire("hekY6");


var $iMnC5 = parcelRequire("iMnC5");

const $52667dbc7d28677d$var$errorImageStyles = {
    root: "_1bsba91z _19pkze3t _2hwxze3t _otyroahv _18u0ze3t _1e0c1txw"
};
const $52667dbc7d28677d$export$7326e6d938a8137b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(8);
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ alt: t1, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = t1;
    } else {
        props = $[1];
        t1 = $[2];
    }
    const alt = t1 === undefined ? "" : t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $52667dbc7d28677d$var$errorImageStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== alt || $[5] !== props || $[6] !== ref) {
        t3 = /*#__PURE__*/ $cozmU.createElement("img", {
            ref: ref,
            alt: alt,
            ...props,
            className: t2
        });
        $[4] = alt;
        $[5] = props;
        $[6] = ref;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ alt: alt = '', ...props }, ref)=>/*#__PURE__*/ $cozmU.createElement("img", {
        ref: ref,
        alt: alt,
        ...props,
        className: (0, $hekY6.default)([
            $52667dbc7d28677d$var$errorImageStyles.root
        ])
    })); // Cannot use Box/xcss: media queries are not supported in @atlaskit/css cssMap
const $52667dbc7d28677d$var$containerStyles = {
    root: "_4cvr1h6o _1bah1h6o _1e0c1txw _1n261g80 _19pk1epz _2hwx1wug _otyrze3t _18u01wug _p12f1ogm _2lx21bp4 _1a6c1bp4"
};
const $52667dbc7d28677d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $52667dbc7d28677d$var$containerStyles.root
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props || $[2] !== ref) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = ref;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props, ref)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            $52667dbc7d28677d$var$containerStyles.root
        ])
    })); // Cannot use Box/xcss: media queries and nested selectors are not supported in @atlaskit/css cssMap
const $52667dbc7d28677d$var$imageOuterStyles = {
    root: "_16jlidpf _1o9zidpf _i0dl1wug _i0dluuw1 _1bah1h6o _1mtkze3t _fxxs1wug _l1ch1osq _fzxlze3t _fdbp1ejb _28hsze3t _1szv1ejb"
};
const $52667dbc7d28677d$export$6cce79b2fcc860dc = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $52667dbc7d28677d$var$imageOuterStyles.root
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props || $[2] !== ref) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = ref;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props, ref)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            $52667dbc7d28677d$var$imageOuterStyles.root
        ])
    })); // Cannot use Box/xcss: media queries are not supported in @atlaskit/css cssMap
const $52667dbc7d28677d$var$titleWrapperStyles = {
    root: "_1e0c1txw _otyrutpp _12gv1h6o"
};
const $52667dbc7d28677d$export$585a3b23e887288b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $52667dbc7d28677d$var$titleWrapperStyles.root
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props || $[2] !== ref) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = ref;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props, ref)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            $52667dbc7d28677d$var$titleWrapperStyles.root
        ])
    }));
const $52667dbc7d28677d$var$buttonContainerStyles = {
    root: "_1e0c1txw _1bah1h6o _y3gn1h6o _19pkpxbi"
};
const $52667dbc7d28677d$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ref: ref,
            xcss: $52667dbc7d28677d$var$buttonContainerStyles.root,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: ref,
        xcss: $52667dbc7d28677d$var$buttonContainerStyles.root,
        ...props
    }));
const $52667dbc7d28677d$var$descriptionWrapperStyles = {
    root: "_1e0c1txw _1n261g80"
};
const $52667dbc7d28677d$export$2bf1f2b0d31b60fc = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ref: ref,
            xcss: $52667dbc7d28677d$var$descriptionWrapperStyles.root,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: ref,
        xcss: $52667dbc7d28677d$var$descriptionWrapperStyles.root,
        ...props
    })); // Cannot use Box/xcss: media queries are not supported in @atlaskit/css cssMap
const $52667dbc7d28677d$var$descriptionStyles = {
    root: "_11c8fhey _syazi7uo _12gv1h6o"
};
const $52667dbc7d28677d$export$393edc798c47379d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $52667dbc7d28677d$var$descriptionStyles.root
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props || $[2] !== ref) {
        t1 = /*#__PURE__*/ $cozmU.createElement("p", {
            ref: ref,
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = ref;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props, ref)=>/*#__PURE__*/ $cozmU.createElement("p", {
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            $52667dbc7d28677d$var$descriptionStyles.root
        ])
    })); // Cannot use Box/xcss: media queries are not supported in @atlaskit/css cssMap
const $52667dbc7d28677d$var$errorTextContainerStyles = {
    root: "_1e0c1txw _1bah1h6o _y3gn1h6o _1n261g80 _1bsb1w8u _2lx21bp4 _4cvr1h6o _1wdbko4j _f44q1osq"
};
const $52667dbc7d28677d$export$5086488b1ac4411e = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $52667dbc7d28677d$var$errorTextContainerStyles.root
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props || $[2] !== ref) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = ref;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props, ref)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ref: ref,
        ...props,
        className: (0, $hekY6.default)([
            $52667dbc7d28677d$var$errorTextContainerStyles.root
        ])
    }));


const $82aaa250216852c4$export$2369ec80391a4c8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$7326e6d938a8137b, {
    alt: "",
    src: (0, (/*@__PURE__*/$parcel$interopDefault($9013f3a7d8ef37c6$exports)))
});
const $82aaa250216852c4$export$c120a0e80fd44ca6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { title: title, body: body, image: image, actions: actions } = t0;
    const t1 = image || $82aaa250216852c4$export$2369ec80391a4c8c;
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$6cce79b2fcc860dc, null, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$585a3b23e887288b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h1",
            size: "large"
        }, title));
        $[2] = title;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== body) {
        t4 = body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$2bf1f2b0d31b60fc, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$393edc798c47379d, null, body));
        $[4] = body;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$5086488b1ac4411e, null, t3, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== actions) {
        t6 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$eddf54ea3db8d0f0, null, actions);
        $[9] = actions;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t2 || $[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$42a852a2b6b56249, {
            "data-test-selector": "error-page"
        }, t2, t5, t6);
        $[11] = t2;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : ({ title: title, body: body, image: image, actions: actions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$42a852a2b6b56249, {
        "data-test-selector": "error-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$6cce79b2fcc860dc, null, image || $82aaa250216852c4$export$2369ec80391a4c8c), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$5086488b1ac4411e, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$585a3b23e887288b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "large"
    }, title)), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$2bf1f2b0d31b60fc, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$393edc798c47379d, null, body))), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52667dbc7d28677d$export$eddf54ea3db8d0f0, null, actions));
};
const $82aaa250216852c4$export$5d76009b056f3e5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] !== props.hasSupportLink) {
        t0 = props.hasSupportLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            rel: "noopener noreferrer",
            target: "_blank",
            href: `${(0, $c9hBE.getAtlassianContextUrl)("support")}/contact/#/`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82aaa250216852c4$var$messages.contactUs));
        $[0] = props.hasSupportLink;
        $[1] = t0;
    } else t0 = $[1];
    const actions = t0;
    let t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82aaa250216852c4$var$messages.title);
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82aaa250216852c4$var$messages.description);
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    const t3 = actions || undefined;
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82aaa250216852c4$export$c120a0e80fd44ca6, {
            title: t1,
            body: t2,
            actions: t3
        });
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : (props)=>{
    const actions = props.hasSupportLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        rel: "noopener noreferrer",
        target: "_blank",
        href: `${(0, $c9hBE.getAtlassianContextUrl)('support')}/contact/#/`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82aaa250216852c4$var$messages.contactUs));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82aaa250216852c4$export$c120a0e80fd44ca6, {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82aaa250216852c4$var$messages.title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82aaa250216852c4$var$messages.description),
        actions: actions || undefined
    });
};
const $82aaa250216852c4$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "pf-home.generic-error-title",
        defaultMessage: "Something went wrong"
    },
    contactUs: {
        id: "ptc-directory.error-boundary.message-link-text",
        defaultMessage: "Contact support"
    },
    description: {
        id: "pf-home.generic-error-description",
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing does not fix things."
    }
});
var $82aaa250216852c4$export$2e2bcd8739ae039 = $82aaa250216852c4$export$c120a0e80fd44ca6;
module.exports["GenericErrorPage"] = $82aaa250216852c4$export$5d76009b056f3e5d;
module.exports["default"] = $82aaa250216852c4$export$2e2bcd8739ae039;

});

parcelRegister("i5VdT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $3970476d1b47c021$var$MOBILE_BREAKPOINT = 480;
const $3970476d1b47c021$var$TABLET_BREAKPOINT = 768;
const $3970476d1b47c021$var$SMALL_DESKTOP_BREAKPOINT = 1024;
const $3970476d1b47c021$var$NARROW_BREAKPOINT = 960;
const $3970476d1b47c021$var$initialState = {
    containerWidth: null
};
const $3970476d1b47c021$var$actions = {
    setContainerWidth: (containerWidth)=>({ setState: setState })=>{
            setState({
                containerWidth: containerWidth
            });
        }
};
const $3970476d1b47c021$var$LayoutStore = (0, $8s9DV.createStore)({
    initialState: $3970476d1b47c021$var$initialState,
    actions: $3970476d1b47c021$var$actions,
    name: 'LayoutStore'
});
const $3970476d1b47c021$var$useLayoutStoreInner = (0, $kBr4q.createHook)($3970476d1b47c021$var$LayoutStore);
const $3970476d1b47c021$var$useIsSmallDesktopOrSmallerInner = (0, $kBr4q.createHook)($3970476d1b47c021$var$LayoutStore, {
    selector: (state)=>!!(state.containerWidth && state.containerWidth < $3970476d1b47c021$var$SMALL_DESKTOP_BREAKPOINT)
});
const $3970476d1b47c021$var$useIsLargeDesktopOrSmallerInner = (0, $kBr4q.createHook)($3970476d1b47c021$var$LayoutStore, {
    selector: (state)=>!!(state.containerWidth && state.containerWidth < 1767)
});
const $3970476d1b47c021$var$useIsTabletOrSmallerInner = (0, $kBr4q.createHook)($3970476d1b47c021$var$LayoutStore, {
    selector: (state)=>!!(state.containerWidth && state.containerWidth < $3970476d1b47c021$var$TABLET_BREAKPOINT)
});
const $3970476d1b47c021$var$useIsMobileInner = (0, $kBr4q.createHook)($3970476d1b47c021$var$LayoutStore, {
    selector: (state)=>!!(state.containerWidth && state.containerWidth < $3970476d1b47c021$var$MOBILE_BREAKPOINT)
});
const $3970476d1b47c021$var$useIsNarrowInner = (0, $kBr4q.createHook)($3970476d1b47c021$var$LayoutStore, {
    selector: (state)=>!!(state.containerWidth && state.containerWidth < $3970476d1b47c021$var$NARROW_BREAKPOINT)
});
const $3970476d1b47c021$export$ee413f68c0e5c346 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $3970476d1b47c021$var$useLayoutStoreInner()[0];
} : ()=>$3970476d1b47c021$var$useLayoutStoreInner()[0];
const $3970476d1b47c021$export$6136bc3b9858cff4 = (0, $kBr4q.createActionsHook)($3970476d1b47c021$var$LayoutStore);
const $3970476d1b47c021$export$293b53b531951db4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $3970476d1b47c021$var$useIsSmallDesktopOrSmallerInner()[0];
} : ()=>$3970476d1b47c021$var$useIsSmallDesktopOrSmallerInner()[0];
const $3970476d1b47c021$export$a6107dd46f961c49 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $3970476d1b47c021$var$useIsLargeDesktopOrSmallerInner()[0];
} : ()=>$3970476d1b47c021$var$useIsLargeDesktopOrSmallerInner()[0];
const $3970476d1b47c021$export$357971c047d61751 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $3970476d1b47c021$var$useIsTabletOrSmallerInner()[0];
} : ()=>$3970476d1b47c021$var$useIsTabletOrSmallerInner()[0];
const $3970476d1b47c021$export$4bf747c2fa517a1a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $3970476d1b47c021$var$useIsNarrowInner()[0];
} : ()=>$3970476d1b47c021$var$useIsNarrowInner()[0];
const $3970476d1b47c021$export$2b96349243a56116 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $3970476d1b47c021$var$useIsMobileInner()[0];
} : ()=>$3970476d1b47c021$var$useIsMobileInner()[0];
module.exports["useLayoutStoreActions"] = $3970476d1b47c021$export$6136bc3b9858cff4;
module.exports["useIsSmallDesktopOrSamller"] = $3970476d1b47c021$export$293b53b531951db4;
module.exports["useIsLargeDesktopOrSmaller"] = $3970476d1b47c021$export$a6107dd46f961c49;
module.exports["useIsTabletOrSmaller"] = $3970476d1b47c021$export$357971c047d61751;
module.exports["useIsLayoutNarrow"] = $3970476d1b47c021$export$4bf747c2fa517a1a;
module.exports["useIsMobile"] = $3970476d1b47c021$export$2b96349243a56116;

});

parcelRegister("aqqtp", function(module, exports) {
// Use defaut timeout from Confluence
// https://stash.atlassian.com/projects/confcloud/repos/confluence-frontend/browse/next/packages/experience-tracker/src/ExperienceTimeout.ts#2
const $fbbf283e30c033fd$export$6a2b57b882ff619b = 60000; // 60s
const $fbbf283e30c033fd$export$c816bd9ab77da948 = 15000; // 15s
var $fbbf283e30c033fd$export$aff1d63763bf8a44 = /*#__PURE__*/ function(UserExperienceNames) {
    UserExperienceNames["CREATE_TEAM"] = "createTeam";
    UserExperienceNames["CREATE_TEAM_OPEN_DIALOG"] = "createTeam/openDialog";
    UserExperienceNames["CREATE_TEAM_SUBMIT"] = "createTeam/create";
    // a compound experience
    UserExperienceNames["TEAM_PROFILE_PAGE"] = "teamProfile/render";
    UserExperienceNames["TEAM_PROFILE_MEMBERS"] = "teamProfile/membersPanel";
    UserExperienceNames["TEAM_PROFILE_AGENTS"] = "teamProfile/agentsPanel";
    UserExperienceNames["TEAM_PROFILE_LINKS"] = "teamProfile/links";
    UserExperienceNames["TEAM_PROFILE_WORKED_ON"] = "teamProfile/workedOn";
    UserExperienceNames["TEAM_PROFILE_TEAMS_CONTAINERS"] = "teamProfile/teamsContainers";
    UserExperienceNames["TEAM_PROFILE_TEAM_ABOUT"] = "teamProfile/teamAboutPanel";
    UserExperienceNames["TEAM_PROFILE_PROJECTS_AND_GOALS"] = "teamProfile/projectsAndGoals";
    UserExperienceNames["TEAM_PROFILE_HELP_POINTERS"] = "teamProfile/helpPointers";
    UserExperienceNames["TEAM_PROFILE_KUDOS"] = "teamProfile/kudos";
    UserExperienceNames["TEAM_PROFILE_GOALS_TAB"] = "teamProfile/goalsTab";
    UserExperienceNames["TEAM_PROFILE_ACTIVITY_TAB"] = "teamProfile/activityTab";
    UserExperienceNames["TEAM_PROFILE_HIERARCHY_TAB"] = "teamProfile/hierarchyTab";
    UserExperienceNames["TEAM_PROFILE_SOFTWARE_COMPONENTS"] = "teamProfile/softwareComponents";
    UserExperienceNames["USER_PROFILE_AI_TOPICS"] = "userProfile/aiTopics";
    // a compound experience
    UserExperienceNames["USER_PROFILE_PAGE"] = "userProfile/render";
    UserExperienceNames["USER_PROFILE_PAGE_SLOW"] = "userProfile/renderSlow";
    UserExperienceNames["USER_PROFILE_WORKED_ON"] = "userProfile/workedOn";
    UserExperienceNames["USER_PROFILE_CONTAINERS"] = "userProfile/container";
    UserExperienceNames["USER_PROFILE_USER_ABOUT"] = "userProfile/userAbout";
    UserExperienceNames["USER_PROFILE_COLLABORATORS"] = "userProfile/collaborators";
    UserExperienceNames["USER_PROFILE_USERS_TEAMS"] = "userProfile/usersTeams";
    UserExperienceNames["USER_PROFILE_USER_MANAGER"] = "userProfile/userManager";
    UserExperienceNames["USER_PROFILE_TAG"] = "userProfile/tag";
    UserExperienceNames["USER_PROFILE_USER_TENURE"] = "userProfile/userTenure";
    // a compound experience
    UserExperienceNames["SEARCH_HOME_PAGE"] = "searchHomePage/render";
    UserExperienceNames["SEARCH_HOME_PAGE_COLLABORATORS"] = "searchHomePage/collaborators";
    UserExperienceNames["SEARCH_HOME_PAGE_YOUR_TEAMS"] = "searchHomePage/yourTeams";
    UserExperienceNames["USER_PROFILE_PROJECTS_AND_GOALS"] = "userProfile/projectsAndGoals";
    UserExperienceNames["USER_PROFILE_MANAGERS_AND_TEAMS"] = "userProfile/managersAndTeams";
    UserExperienceNames["USER_PROFILE_KUDOS"] = "userProfile/kudos";
    // edit team name or description from Team profile page
    UserExperienceNames["EDIT_TEAM_NAME_OR_DESCRIPTION"] = "editTeamNameOrDescription";
    // remove team member
    UserExperienceNames["REMOVE_TEAM_MEMBER"] = "removeTeamMember";
    UserExperienceNames["REMOVE_TEAM_MEMBER_OPEN_DIALOG"] = "removeTeamMember/openDialog";
    UserExperienceNames["REMOVE_TEAM_MEMBER_SUBMIT"] = "removeTeamMember/submit";
    // upload user avatar from User profile page
    UserExperienceNames["UPLOAD_USER_AVATAR"] = "uploadUserAvatar";
    UserExperienceNames["UPLOAD_HEADER_IMAGE"] = "uploadHeaderImage";
    // team membership control changing
    UserExperienceNames["MEMBERSHIP_CONTROL_CHANGE"] = "membershipControl/change";
    UserExperienceNames["MEMBERSHIP_CONTROL_HANDLE_REQUESTS"] = "membershipControl/handleRequests";
    UserExperienceNames["MEMBERSHIP_CONTROL_TEAM_TYPE"] = "membershipControl/teamType";
    // agent profile page
    UserExperienceNames["AGENT_PROFILE_PAGE"] = "agentProfile/render";
    return UserExperienceNames;
}({});
const $fbbf283e30c033fd$export$f6872ed66cc3dc3a = [
    "teamProfile/membersPanel",
    "teamProfile/links",
    "teamProfile/workedOn",
    "teamProfile/teamAboutPanel"
];
const $fbbf283e30c033fd$export$e302f7a9166a33eb = [
    "userProfile/userAbout",
    "userProfile/usersTeams",
    "userProfile/workedOn",
    "userProfile/container"
];
const $fbbf283e30c033fd$export$ab5c192ffd15cb07 = [
    "searchHomePage/collaborators",
    "searchHomePage/yourTeams"
];
const $fbbf283e30c033fd$export$bebaacf4c0d1b056 = [
    "createTeam/openDialog",
    "createTeam/create"
];
const $fbbf283e30c033fd$export$74d8df99c7474c3b = [
    "removeTeamMember/openDialog",
    "removeTeamMember/submit"
];
module.exports["DEFAULT_TIMEOUT_USER_EXP"] = $fbbf283e30c033fd$export$6a2b57b882ff619b;
module.exports["UserExperienceNames"] = $fbbf283e30c033fd$export$aff1d63763bf8a44;
module.exports["TEAM_PROFILE_PAGE_SUB_EVENT_NAMES"] = $fbbf283e30c033fd$export$f6872ed66cc3dc3a;
module.exports["USER_PROFILE_PAGE_SUB_EVENT_NAMES"] = $fbbf283e30c033fd$export$e302f7a9166a33eb;
module.exports["SEARCH_HOME_PAGE_SUB_EVENT_NAMES"] = $fbbf283e30c033fd$export$ab5c192ffd15cb07;
module.exports["CREATE_TEAM_FLOW_SUB_EVENT_NAMES"] = $fbbf283e30c033fd$export$bebaacf4c0d1b056;

});

parcelRegister("77v81", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dNbb2 = parcelRequire("dNbb2");


var $p4wJt = parcelRequire("p4wJt");

const $710b4f93c862a582$export$3ec42c6cc9df311c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useExpTrackerStart(options) {
    const $ = (0, $bDgLe.c)(28);
    const { id: id, name: name, timeout: timeout, isTriggerOnMount: t0, subExperiences: subExperiences, latencySloMs: latencySloMs, startAttributes: startAttributes, onSuccess: onSuccess } = options;
    const isTriggerOnMount = t0 === undefined ? true : t0;
    const analytics = (0, $p4wJt.default)();
    let t1;
    if ($[0] !== analytics) {
        t1 = analytics.expTracker();
        $[0] = analytics;
        $[1] = t1;
    } else t1 = $[1];
    const tracker = t1;
    let t2;
    if ($[2] !== id || $[3] !== latencySloMs || $[4] !== name || $[5] !== onSuccess || $[6] !== startAttributes || $[7] !== subExperiences || $[8] !== timeout || $[9] !== tracker) {
        t2 = ()=>{
            const options_0 = {
                id: id,
                name: name,
                timeout: timeout,
                collect: undefined,
                attributes: startAttributes,
                onSuccess: onSuccess
            };
            if (subExperiences) options_0.collect = (0, $dNbb2.collectAll)(subExperiences);
            if (latencySloMs) options_0.attributes = {
                latencySlo: latencySloMs
            };
            tracker.start(options_0);
        };
        $[2] = id;
        $[3] = latencySloMs;
        $[4] = name;
        $[5] = onSuccess;
        $[6] = startAttributes;
        $[7] = subExperiences;
        $[8] = timeout;
        $[9] = tracker;
        $[10] = t2;
    } else t2 = $[10];
    const triggerStartEvent = t2;
    let t3;
    if ($[11] !== name || $[12] !== tracker) {
        t3 = ()=>{
            tracker.succeed({
                name: name
            });
        };
        $[11] = name;
        $[12] = tracker;
        $[13] = t3;
    } else t3 = $[13];
    const triggerSuccessEvent = t3;
    let t4;
    if ($[14] !== name || $[15] !== tracker) {
        t4 = (error)=>{
            tracker.stopOnError({
                name: name,
                error: error
            });
        };
        $[14] = name;
        $[15] = tracker;
        $[16] = t4;
    } else t4 = $[16];
    const triggerFailEvent = t4;
    let t5;
    if ($[17] !== name || $[18] !== tracker) {
        t5 = (reason)=>{
            tracker.abort({
                name: name,
                reason: reason
            });
        };
        $[17] = name;
        $[18] = tracker;
        $[19] = t5;
    } else t5 = $[19];
    const triggerAbortEvent = t5;
    let t6;
    if ($[20] !== isTriggerOnMount || $[21] !== triggerStartEvent) {
        t6 = ()=>{
            if (isTriggerOnMount) triggerStartEvent();
        };
        $[20] = isTriggerOnMount;
        $[21] = triggerStartEvent;
        $[22] = t6;
    } else t6 = $[22];
    (0, $cozmU.useState)(t6);
    let t7;
    if ($[23] !== triggerAbortEvent || $[24] !== triggerFailEvent || $[25] !== triggerStartEvent || $[26] !== triggerSuccessEvent) {
        t7 = {
            start: triggerStartEvent,
            succeed: triggerSuccessEvent,
            abort: triggerAbortEvent,
            fail: triggerFailEvent
        };
        $[23] = triggerAbortEvent;
        $[24] = triggerFailEvent;
        $[25] = triggerStartEvent;
        $[26] = triggerSuccessEvent;
        $[27] = t7;
    } else t7 = $[27];
    return t7;
} : function useExpTrackerStart(options) {
    const { id: id, name: name, timeout: timeout, isTriggerOnMount: isTriggerOnMount = true, subExperiences: subExperiences, latencySloMs: latencySloMs, startAttributes: startAttributes, onSuccess: onSuccess } = options;
    const analytics = (0, $p4wJt.default)();
    const tracker = analytics.expTracker();
    const triggerStartEvent = (0, $cozmU.useCallback)(()=>{
        const options_0 = {
            id: id,
            name: name,
            timeout: timeout,
            collect: undefined,
            attributes: startAttributes,
            onSuccess: onSuccess
        };
        if (subExperiences) options_0.collect = (0, $dNbb2.collectAll)(subExperiences);
        if (latencySloMs) options_0.attributes = {
            latencySlo: latencySloMs
        };
        tracker.start(options_0);
    }, [
        id,
        name,
        timeout,
        startAttributes,
        onSuccess,
        subExperiences,
        latencySloMs,
        tracker
    ]);
    const triggerSuccessEvent = (0, $cozmU.useCallback)(()=>{
        tracker.succeed({
            name: name
        });
    }, [
        name,
        tracker
    ]);
    const triggerFailEvent = (0, $cozmU.useCallback)((error)=>{
        tracker.stopOnError({
            name: name,
            error: error
        });
    }, [
        name,
        tracker
    ]);
    const triggerAbortEvent = (0, $cozmU.useCallback)((reason)=>{
        tracker.abort({
            name: name,
            reason: reason
        });
    }, [
        name,
        tracker
    ]);
    // we use 'useState' here because we want to trigger start event as soon as possible, before rendering component,
    (0, $cozmU.useState)(()=>{
        // default behaviour: trigger start event when mounting.
        // "isTriggerOnMount=false" is allow to turn off the default behaviour.
        if (isTriggerOnMount) triggerStartEvent();
    });
    // allow to trigger start event whenever consumers want like inside onClick.
    return {
        start: triggerStartEvent,
        succeed: triggerSuccessEvent,
        abort: triggerAbortEvent,
        fail: triggerFailEvent
    };
};
module.exports["useExpTrackerStart"] = $710b4f93c862a582$export$3ec42c6cc9df311c;

});

parcelRegister("dNbb2", function(module, exports) {

var $cqtVU = parcelRequire("cqtVU");

function $d4a9f72d8818b0a8$export$feb7963ae429f97f(experienceNames) {
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')));
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $cqtVU.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
}
function $d4a9f72d8818b0a8$export$79dbdd3e43727beb(experienceNames) {
    return (events, experience)=>experience.stopOn(events.find((event)=>(0, $cqtVU.isStop)(event) && (0, $cqtVU.hasName)(event, ...experienceNames)));
}
module.exports["collectAll"] = $d4a9f72d8818b0a8$export$feb7963ae429f97f;

});

parcelRegister("lGzNt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $d8Itl = parcelRequire("d8Itl");


var $p4wJt = parcelRequire("p4wJt");

const $589b19ff9cfe9723$export$432668e70196929c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useExpTrackerStop(options) {
    const $ = (0, $bDgLe.c)(8);
    const { name: name, error: error, checkShouldAbort: checkShouldAbort } = options;
    const analytics = (0, $p4wJt.default)();
    let t0;
    if ($[0] !== analytics) {
        t0 = analytics.expTracker();
        $[0] = analytics;
        $[1] = t0;
    } else t0 = $[1];
    const tracker = t0;
    let t1;
    let t2;
    if ($[2] !== checkShouldAbort || $[3] !== error || $[4] !== name || $[5] !== tracker) {
        t1 = ()=>{
            const triggerStopEvent = ()=>{
                if (!error) return;
                if ($589b19ff9cfe9723$var$isRateLimitError(error)) {
                    abortExpTracker(`Ignoring 429 error: ${error.message}`);
                    return;
                }
                tracker.stopOnError({
                    name: name,
                    error: error
                });
            };
            const abortExpTracker = (reason)=>{
                tracker.abort({
                    name: name,
                    reason: reason
                });
            };
            if (error) {
                const reason_0 = checkShouldAbort ? checkShouldAbort(error) : undefined;
                if (typeof reason_0 === "string" || $589b19ff9cfe9723$var$isRateLimitError(error)) abortExpTracker(reason_0 ?? `Ignoring 429 error: ${error.message}`);
                else triggerStopEvent();
            }
        };
        t2 = [
            checkShouldAbort,
            error,
            name,
            tracker
        ];
        $[2] = checkShouldAbort;
        $[3] = error;
        $[4] = name;
        $[5] = tracker;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : function useExpTrackerStop(options) {
    const { name: name, error: error, checkShouldAbort: checkShouldAbort } = options;
    const analytics = (0, $p4wJt.default)();
    const tracker = analytics.expTracker();
    (0, $cozmU.useEffect)(()=>{
        const triggerStopEvent = ()=>{
            if (!error) return;
            // If error has a statusCode of 429, abort instead.
            if ($589b19ff9cfe9723$var$isRateLimitError(error)) {
                abortExpTracker(`Ignoring 429 error: ${error.message}`);
                return;
            }
            tracker.stopOnError({
                name: name,
                error: error
            });
        };
        const abortExpTracker = (reason)=>{
            tracker.abort({
                name: name,
                reason: reason
            });
        };
        if (error) {
            const reason_0 = checkShouldAbort ? checkShouldAbort(error) : undefined;
            if (typeof reason_0 === 'string' || $589b19ff9cfe9723$var$isRateLimitError(error)) abortExpTracker(reason_0 ?? `Ignoring 429 error: ${error.message}`);
            else triggerStopEvent();
        }
    }, [
        checkShouldAbort,
        error,
        name,
        tracker
    ]);
};
const $589b19ff9cfe9723$var$isRateLimitError = (error)=>{
    if (error instanceof (0, $d8Itl.UseQueryLightError) && error.networkError) return $589b19ff9cfe9723$var$isRateLimitError(error.networkError);
    return 'statusCode' in error && error.statusCode === 429 || 'status' in error && error.status === 429 || error?.message?.includes('429');
};
module.exports["useExpTrackerStop"] = $589b19ff9cfe9723$export$432668e70196929c;

});

parcelRegister("d8Itl", function(module, exports) {
var $5f58e2e971c4aa53$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
class $5f58e2e971c4aa53$export$7f29b23735f2fedd extends Error {
    constructor(message){
        super(message);
        // AGG standard
        this.extensions = void 0;
        this.message = void 0;
        this.path = void 0;
        this.category = void 0;
        this.type = void 0;
        this.message = message;
    }
}
class $5f58e2e971c4aa53$export$a1c33d09dbc37a86 extends Error {
    constructor(message, name, graphQLErrors, networkError, extensions, extraInfo){
        super(message);
        this.networkError = void 0;
        this.graphQLErrors = void 0;
        this.extensions = void 0;
        this.extraInfo = void 0;
        this.graphQLErrors = graphQLErrors;
        this.networkError = networkError;
        this.extensions = extensions;
        this.extraInfo = extraInfo;
        if (name) this.name = name;
    }
}
module.exports["UseQueryLightError"] = $5f58e2e971c4aa53$export$a1c33d09dbc37a86;

});

parcelRegister("249jk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $dZPDC = parcelRequire("dZPDC");


var $jmOWE = parcelRequire("jmOWE");


var $jVEhV = parcelRequire("jVEhV");

const $ca8a85c714ddb5e4$export$1aa77d8d4b0ee493 = {
    '': 'STANDALONE',
    'site-directory': 'STANDALONE',
    'confluence-directory': 'CONFLUENCE',
    'jira-directory': 'JIRA',
    'teamcentral-directory': 'TOWNSQUARE',
    'home-directory': 'HOME'
};


const $51cd3f14d6b8bd50$export$28456d095a642fd = 'internal.browse-users-allowed';
const $51cd3f14d6b8bd50$var$actions = {
    /**
   * Fetches bup settings from pf-directory/legion service
   * @param product - Product name.
   * @param cloudId - Cloud Id.
   * @private
   * @deprecated Use getSettingsNext instead.
   */ getSettings: (product, cloudId)=>async ({ getState: getState, setState: setState })=>{
            if (getState().isFetching || getState().hasLoadedSettings) return;
            setState({
                isFetching: true
            });
            try {
                const directorySettingPromise = cloudId ? (0, $dZPDC.teamsClient).querySettings(cloudId, product) : Promise.resolve({
                    [$51cd3f14d6b8bd50$export$28456d095a642fd]: true
                });
                return await (0, $jmOWE.promiseWithDefault)(directorySettingPromise, {
                    [$51cd3f14d6b8bd50$export$28456d095a642fd]: false
                }).then(({ value: browseUsersEnabled, success: settingsSuccess })=>{
                    const settingsFromRequests = {
                        // If settings cannot be accessed, default to permission denied.
                        [$51cd3f14d6b8bd50$export$28456d095a642fd]: false,
                        ...browseUsersEnabled
                    };
                    // Fallback as needed to compute effective flag values
                    const finalSettings = {
                        ...(0, $jVEhV.getSettingsFromStorage)() || {},
                        ...settingsFromRequests
                    };
                    setState({
                        hasLoadedSettings: true,
                        hasErrorOnFetchSettings: !settingsSuccess,
                        hasBrowseUsersPermission: !!finalSettings[$51cd3f14d6b8bd50$export$28456d095a642fd],
                        settings: finalSettings
                    });
                });
            } catch  {
                setState({
                    hasErrorOnFetchSettings: true,
                    hasLoadedSettings: true
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        },
    /**
   * Fetches bup settings from pf-directory/legion service, but with a different method signature.
   * @param product - Product name.
   * @param cloudId - Cloud Id.
   */ getSettingsNext: ({ appName: appName, cloudId: cloudId, pushOperationalEvent: pushOperationalEvent })=>async ({ getState: getState, setState: setState })=>{
            if (getState().isFetching || getState().hasLoadedSettings) return;
            setState({
                isFetching: true
            });
            try {
                const product = appName ? (0, $ca8a85c714ddb5e4$export$1aa77d8d4b0ee493)[appName] : undefined;
                const directorySettingPromise = cloudId ? (0, $dZPDC.teamsClient).querySettings(cloudId, product) : Promise.resolve({
                    [$51cd3f14d6b8bd50$export$28456d095a642fd]: true
                });
                return await (0, $jmOWE.promiseWithDefault)(directorySettingPromise, {
                    [$51cd3f14d6b8bd50$export$28456d095a642fd]: false
                }).then(({ value: browseUsersEnabled, success: settingsSuccess })=>{
                    const settingsFromRequests = {
                        // If settings cannot be accessed, default to permission denied.
                        [$51cd3f14d6b8bd50$export$28456d095a642fd]: false,
                        ...browseUsersEnabled
                    };
                    // Fallback as needed to compute effective flag values
                    const finalSettings = {
                        ...(0, $jVEhV.getSettingsFromStorage)() || {},
                        ...settingsFromRequests
                    };
                    pushOperationalEvent(settingsSuccess);
                    setState({
                        hasLoadedSettings: true,
                        hasErrorOnFetchSettings: !settingsSuccess,
                        hasBrowseUsersPermission: !!finalSettings[$51cd3f14d6b8bd50$export$28456d095a642fd],
                        settings: finalSettings
                    });
                });
            } catch  {
                pushOperationalEvent(false);
                setState({
                    hasErrorOnFetchSettings: true,
                    hasLoadedSettings: true
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        }
};
const $51cd3f14d6b8bd50$var$initialState = {
    hasLoadedSettings: false,
    hasErrorOnFetchSettings: false,
    hasBrowseUsersPermission: false,
    isFetching: false,
    settings: {
        [$51cd3f14d6b8bd50$export$28456d095a642fd]: false,
        ...(0, $jVEhV.getSettingsFromStorage)() || {}
    }
};
/**
 * Manage states of settings
 */ const $51cd3f14d6b8bd50$var$Store = (0, $8s9DV.createStore)({
    initialState: $51cd3f14d6b8bd50$var$initialState,
    actions: $51cd3f14d6b8bd50$var$actions,
    name: 'Settings'
});
const $51cd3f14d6b8bd50$export$8376625f8bb18347 = (0, $j8on0.createContainer)($51cd3f14d6b8bd50$var$Store, {
    onInit: ()=>({ setState: setState }, state)=>{
            setState(state);
        }
});
const $51cd3f14d6b8bd50$export$9115b42802a3e44f = (0, $kBr4q.createHook)($51cd3f14d6b8bd50$var$Store);
const $51cd3f14d6b8bd50$export$f2df9067cb58ea32 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (flagName)=>{
    const [t0] = $51cd3f14d6b8bd50$export$9115b42802a3e44f();
    const { settings: settings } = t0;
    return settings[flagName];
} : (flagName)=>{
    const [{ settings: settings }] = $51cd3f14d6b8bd50$export$9115b42802a3e44f();
    return settings[flagName];
};
module.exports["useSettings"] = $51cd3f14d6b8bd50$export$9115b42802a3e44f;
module.exports["useSettingsFeatureFlag"] = $51cd3f14d6b8bd50$export$f2df9067cb58ea32;

});

parcelRegister("24Rm0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $82d131a88fd0115a$var$defaultNavigationState = {
    contextSpaPaths: [],
    contextEntryPoint: null
};
const $82d131a88fd0115a$var$defaultClientConfigState = {
    cloudId: null,
    stargateRoot: '',
    env: undefined
};
const $82d131a88fd0115a$var$defaultTeamsProductConfigState = {
    appName: null,
    productName: null,
    isJiraAvailable: false,
    openLinksInNewTab: false
};
const $82d131a88fd0115a$var$defaultTeamsPreviewPanelConfigState = {
    openPreviewPanel: ()=>{}
};
const $82d131a88fd0115a$var$defaultEmbedConfigState = {
    openGiveKudosInNewTab: false
};
const $82d131a88fd0115a$var$defaultState = {
    ...$82d131a88fd0115a$var$defaultNavigationState,
    ...$82d131a88fd0115a$var$defaultClientConfigState,
    ...$82d131a88fd0115a$var$defaultTeamsProductConfigState,
    ...$82d131a88fd0115a$var$defaultTeamsPreviewPanelConfigState,
    ...$82d131a88fd0115a$var$defaultEmbedConfigState,
    docTitle: {}
};
const $82d131a88fd0115a$var$actions = {
    setNavigationConfig: (navigationConfig)=>({ setState: setState })=>{
            setState({
                ...navigationConfig
            });
        },
    setClientConfig: (clientConfig)=>({ setState: setState })=>{
            setState({
                ...clientConfig
            });
        },
    setTeamsProductConfig: (teamsProductConfig)=>({ setState: setState })=>{
            setState({
                ...teamsProductConfig
            });
        },
    setTeamsPreviewPanelConfig: (teamsPreviewPanelConfig)=>({ setState: setState })=>{
            setState({
                ...teamsPreviewPanelConfig
            });
        },
    setEmbedConfig: (embedConfig)=>({ setState: setState })=>{
            setState({
                ...embedConfig
            });
        },
    // Set all config at once
    setAppConfig: (appConfig)=>({ setState: setState })=>{
            setState({
                ...appConfig
            });
        }
};
const $82d131a88fd0115a$var$AppConfigStore = (0, $8s9DV.createStore)({
    initialState: $82d131a88fd0115a$var$defaultState,
    actions: $82d131a88fd0115a$var$actions
});
const $82d131a88fd0115a$export$61884cfbde7fd829 = (0, $kBr4q.createHook)($82d131a88fd0115a$var$AppConfigStore);
const $82d131a88fd0115a$var$useAppConfigActions = (0, $kBr4q.createHook)($82d131a88fd0115a$var$AppConfigStore, {
    selector: null
});
const $82d131a88fd0115a$export$ace1f350f4f044c0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $82d131a88fd0115a$export$61884cfbde7fd829()[0];
} : ()=>$82d131a88fd0115a$export$61884cfbde7fd829()[0];
const $82d131a88fd0115a$export$b652cf4936246835 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $82d131a88fd0115a$var$useAppConfigActions()[1];
} : ()=>{
    return $82d131a88fd0115a$var$useAppConfigActions()[1];
};
const $82d131a88fd0115a$export$7b278989f04c1040 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $82d131a88fd0115a$export$ace1f350f4f044c0().appName;
} : ()=>$82d131a88fd0115a$export$ace1f350f4f044c0().appName;
const $82d131a88fd0115a$export$e482f4662aebc4a0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = $82d131a88fd0115a$export$ace1f350f4f044c0();
    let t0;
    if ($[0] !== contextEntryPoint || $[1] !== contextSpaPaths) {
        t0 = {
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint
        };
        $[0] = contextEntryPoint;
        $[1] = contextSpaPaths;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = $82d131a88fd0115a$export$ace1f350f4f044c0();
    return {
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint
    };
};
module.exports["useAppConfigStoreState"] = $82d131a88fd0115a$export$ace1f350f4f044c0;
module.exports["useSetTeamsConfigActions"] = $82d131a88fd0115a$export$b652cf4936246835;
module.exports["useNavigationState"] = $82d131a88fd0115a$export$e482f4662aebc4a0;

});

parcelRegister("jmOWE", function(module, exports) {
function $d299e67343e78a7f$export$a970b469503acdc8(promise, defaultValue) {
    return promise.then((value)=>({
            value: value,
            success: true
        })).catch(()=>({
            value: defaultValue,
            success: false
        }));
}
module.exports["promiseWithDefault"] = $d299e67343e78a7f$export$a970b469503acdc8;

});

parcelRegister("jVEhV", function(module, exports) {

var $kz7tR = parcelRequire("kz7tR");


var $vQsx2 = parcelRequire("vQsx2");


var $1Ch8o = parcelRequire("1Ch8o");

const $b5a6056fe5593c68$var$STORAGE_KEY_SETTINGS = 'atlassian.ptc-directory.settings';
function $b5a6056fe5593c68$export$d9d01ff109db30f0(settings) {
    (0, $vQsx2.default).setItem($b5a6056fe5593c68$var$STORAGE_KEY_SETTINGS, JSON.stringify(settings));
    $b5a6056fe5593c68$export$455c5cbefb010abd(settings);
}
function $b5a6056fe5593c68$export$b40bc67e97afc0ed() {
    const settingsString = (0, $vQsx2.default).getItem($b5a6056fe5593c68$var$STORAGE_KEY_SETTINGS);
    try {
        const parsed = settingsString ? JSON.parse(settingsString) : null;
        if ($b5a6056fe5593c68$var$isStringBooleanDictionary(parsed)) return parsed;
        return null;
    } catch (e) {
        (0, $kz7tR.logException)(e, 'Could not get settings from storage', {
            locallyStoredSettings: settingsString
        });
        return null;
    }
}
const $b5a6056fe5593c68$var$effectiveFlags = {
    ...(0, $1Ch8o.DEFAULT_FEATURE_FLAGS),
    ...$b5a6056fe5593c68$export$b40bc67e97afc0ed() || {}
};
function $b5a6056fe5593c68$export$455c5cbefb010abd(newFlags) {
    Object.assign($b5a6056fe5593c68$var$effectiveFlags, newFlags);
}
/**
 * We use this function to validate that the settings retrieved from local storage are of the correct shape.
 * We intentionally don't check against explicit keys, as keys may have changed since being stored.
 */ function $b5a6056fe5593c68$var$isStringBooleanDictionary(result) {
    return result !== null && Object.keys(result).every((resultKey)=>typeof resultKey === 'string' && typeof result[resultKey] === 'boolean');
}
function $b5a6056fe5593c68$export$2f63519103163252(featureFlag) {
    return Object.keys((0, $1Ch8o.PRODUCT_FEATURE_FLAGS)).includes(featureFlag);
}
function $b5a6056fe5593c68$export$ba72073d757a1bc2(flag) {
    return $b5a6056fe5593c68$var$effectiveFlags[flag];
}
module.exports["getSettingsFromStorage"] = $b5a6056fe5593c68$export$b40bc67e97afc0ed;
module.exports["isFlagEnabled"] = $b5a6056fe5593c68$export$ba72073d757a1bc2;

});

parcelRegister("vQsx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4104933e1cee74c$export$2e2bcd8739ae039);

var $kz7tR = parcelRequire("kz7tR");

const $d4104933e1cee74c$var$PREFIX = 'ptc-dir-ui.';
const $d4104933e1cee74c$var$memoryLocalStorage = {
    data: {},
    setItem: (key, value)=>{
        $d4104933e1cee74c$var$memoryLocalStorage.data[key] = value;
    },
    getItem: (key)=>{
        return $d4104933e1cee74c$var$memoryLocalStorage.data[key];
    },
    removeItem: (key)=>{
        delete $d4104933e1cee74c$var$memoryLocalStorage.data[key];
    }
};
// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
const $d4104933e1cee74c$var$localStorage = window.localStorage || $d4104933e1cee74c$var$memoryLocalStorage;
var // A facade for browser localstorage.
$d4104933e1cee74c$export$2e2bcd8739ae039 = {
    isQuotaExceeded () {
        const key = `${$d4104933e1cee74c$var$PREFIX}:${Date.now()}`;
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            $d4104933e1cee74c$var$localStorage.setItem(key, 'test');
        } catch (e) {
            return true;
        } finally{
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            $d4104933e1cee74c$var$localStorage.removeItem(key);
        }
        return false;
    },
    setItem (key, value) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            $d4104933e1cee74c$var$localStorage.setItem($d4104933e1cee74c$var$PREFIX + key, value);
            return true;
        } catch (error) {
            // maybe we can use cookie as alternative storage
            (0, $kz7tR.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return false;
    },
    getItem (key) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            return $d4104933e1cee74c$var$localStorage.getItem($d4104933e1cee74c$var$PREFIX + key);
        } catch (error) {
            (0, $kz7tR.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return null;
    },
    getItemSafely (key, defaultValue, fallback) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const storedValue = $d4104933e1cee74c$var$localStorage.getItem($d4104933e1cee74c$var$PREFIX + key);
            if (storedValue) return storedValue;
            if (this.setItem(key, defaultValue)) return defaultValue;
        } catch (error) {
            (0, $kz7tR.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return fallback;
    }
};

});

parcelRegister("1Ch8o", function(module, exports) {
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
// This is a list of feature flags that are overwritable by products. The defaults are still loaded from the client
const $912068c2df06b578$export$f55f538942f87030 = {};
const $912068c2df06b578$export$f38af5fc86a6e665 = {
    'ptc-directory-ui.enable.cancel-join-requests-silently': false,
    'ptc-directory-ui.deny-open-sites-in-fe': false,
    'ptc-directory-ui.enable.atlas-team-health-monitor': false,
    ...$912068c2df06b578$export$f55f538942f87030
};
module.exports["PRODUCT_FEATURE_FLAGS"] = $912068c2df06b578$export$f55f538942f87030;
module.exports["DEFAULT_FEATURE_FLAGS"] = $912068c2df06b578$export$f38af5fc86a6e665;

});


//# sourceMappingURL=initializeUFOPublisher.33a02167.js.map
